import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import createEmotionStyled from 'create-emotion-styled';
import createEmotion from 'create-emotion';
import classnames from 'classnames';
import { withTheme } from 'emotion-theming';
var theme = {
  baseFontSize: 16
}; //DEBTxCYBG pull this from theme component or global?

var baseSpacing = 8;

var spacing = function spacing(value) {
  var fontMultiple = value * baseSpacing;
  var rems = fontMultiple / theme.baseFontSize;
  return rems + "rem";
};

var breakpoints = {
  xs1: '0',
  xs2: '480px',
  sm1: '540px',
  sm2: '640px',
  md1: '768px',
  md2: '960px',
  lg1: '1024px',
  lg2: '1280px',
  lg3: '1328px',
  xl1: '1420px',
  xl2: '1920px'
};
/* Font size config: usage example ${fontSize('arran')} */

var fontConfig = {
  lewis: {
    xs1: {
      fontSize: 37,
      lineHeight: 1.189
    },
    sm1: {
      fontSize: 37,
      lineHeight: 1.189
    },
    md1: {
      fontSize: 45,
      lineHeight: 1.067
    },
    lg1: {
      fontSize: 52,
      lineHeight: 1.154
    },
    xl1: {
      fontSize: 52,
      lineHeight: 1.154
    }
  },
  skye: {
    xs1: {
      fontSize: 32,
      lineHeight: 1.125
    },
    sm1: {
      fontSize: 32,
      lineHeight: 1.125
    },
    md1: {
      fontSize: 40,
      lineHeight: 1.1
    },
    lg1: {
      fontSize: 45,
      lineHeight: 1.156
    },
    xl1: {
      fontSize: 45,
      lineHeight: 1.156
    }
  },
  shetland: {
    xs1: {
      fontSize: 29,
      lineHeight: 1.241
    },
    sm1: {
      fontSize: 29,
      lineHeight: 1.241
    },
    md1: {
      fontSize: 34,
      lineHeight: 1.176
    },
    lg1: {
      fontSize: 39,
      lineHeight: 1.128
    },
    xl1: {
      fontSize: 39,
      lineHeight: 1.128
    }
  },
  mull: {
    xs1: {
      fontSize: 26,
      lineHeight: 1.231
    },
    sm1: {
      fontSize: 26,
      lineHeight: 1.231
    },
    md1: {
      fontSize: 29,
      lineHeight: 1.241
    },
    lg1: {
      fontSize: 33,
      lineHeight: 1.212
    },
    xl1: {
      fontSize: 33,
      lineHeight: 1.212
    }
  },
  islay: {
    xs1: {
      fontSize: 23,
      lineHeight: 1.217
    },
    sm1: {
      fontSize: 23,
      lineHeight: 1.217
    },
    md1: {
      fontSize: 25,
      lineHeight: 1.28
    },
    lg1: {
      fontSize: 28,
      lineHeight: 1.286
    },
    xl1: {
      fontSize: 28,
      lineHeight: 1.286
    }
  },
  orkney: {
    xs1: {
      fontSize: 20,
      lineHeight: 1.4
    },
    sm1: {
      fontSize: 20,
      lineHeight: 1.4
    },
    md1: {
      fontSize: 22,
      lineHeight: 1.273
    },
    lg1: {
      fontSize: 25,
      lineHeight: 1.28
    },
    xl1: {
      fontSize: 25,
      lineHeight: 1.28
    }
  },
  arran: {
    xs1: {
      fontSize: 18,
      lineHeight: 1.333
    },
    sm1: {
      fontSize: 18,
      lineHeight: 1.333
    },
    md1: {
      fontSize: 19,
      lineHeight: 1.474
    },
    lg1: {
      fontSize: 21,
      lineHeight: 1.333
    },
    xl1: {
      fontSize: 21,
      lineHeight: 1.333
    }
  },
  jura: {
    xs1: {
      fontSize: 16,
      lineHeight: 1.5
    },
    sm1: {
      fontSize: 16,
      lineHeight: 1.5
    },
    md1: {
      fontSize: 16,
      lineHeight: 1.5
    },
    lg1: {
      fontSize: 18,
      lineHeight: 1.556
    },
    xl1: {
      fontSize: 18,
      lineHeight: 1.556
    }
  },
  uist: {
    xs1: {
      fontSize: 14,
      lineHeight: 1.429
    },
    sm1: {
      fontSize: 14,
      lineHeight: 1.429
    },
    md1: {
      fontSize: 14,
      lineHeight: 1.429
    },
    lg1: {
      fontSize: 16,
      lineHeight: 1.5
    },
    xl1: {
      fontSize: 16,
      lineHeight: 1.5
    }
  },
  bute: {
    xs1: {
      fontSize: 12,
      lineHeight: 1.333
    },
    sm1: {
      fontSize: 12,
      lineHeight: 1.333
    },
    md1: {
      fontSize: 13,
      lineHeight: 1.538
    },
    lg1: {
      fontSize: 13,
      lineHeight: 1.538
    },
    xl1: {
      fontSize: 13,
      lineHeight: 1.538
    }
  },
  cumbrae: {
    xs1: {
      fontSize: 11,
      lineHeight: 1.455
    },
    sm1: {
      fontSize: 11,
      lineHeight: 1.455
    },
    md1: {
      fontSize: 12,
      lineHeight: 1.333
    },
    lg1: {
      fontSize: 12,
      lineHeight: 1.333
    },
    xl1: {
      fontSize: 12,
      lineHeight: 1.333
    }
  }
};

var generateSASS = function generateSASS(mqBreakpoint, size, lineHeight) {
  var styles = '';

  if (parseInt(mqBreakpoint) === 0) {
    styles = 'font-size: ' + size + 'px; line-height: ' + lineHeight + ';';
  } else {
    styles = '\n      @media (min-width: ' + mqBreakpoint + ') {\n        font-size: ' + size + 'px;\n        line-height: ' + lineHeight + ';\n      } \n    ';
  }

  return styles;
};

var fontSizes = {};

for (var _fontSize in fontConfig) {
  if (fontConfig.hasOwnProperty(_fontSize)) {
    var style = '';

    for (var breakpoint in fontConfig[_fontSize]) {
      if (fontConfig[_fontSize].hasOwnProperty(breakpoint)) {
        var _fontConfig$_fontSize = fontConfig[_fontSize][breakpoint],
            size = _fontConfig$_fontSize.fontSize,
            lineHeight = _fontConfig$_fontSize.lineHeight;
        style += generateSASS(breakpoints[breakpoint], size, lineHeight);
      }
    }

    fontSizes[_fontSize] = style;
  }
}

var fontSize = function fontSize(font) {
  return fontSizes[font];
};

var layers = {
  datepicker1: 2147483647,
  globalTakeover: 1051,
  loader: 1051,
  modal1: 1050,
  modal2: 1040,
  localTakeover: 1020,
  popper: 110,
  webchat: 110,
  multiButtonModal: 104,
  wideModal: 104,
  accountLegacyPanelDropdown: 100,
  modal3: 100,
  paymentAccountSelector1: 16,
  paymentAccountSelector2: 15,
  checkboxToggleOffIcon: 10,
  comparisonTable: 10,
  accountSelectDropdown: 10,
  currencySelectDropdown: 10,
  header: 10,
  listPayment: 10,
  payeeFooterBar: 9,
  payeeList: 9,
  datepicker2: 5,
  searchAndSelect2: 5,
  searchAndSelect1: 3,
  datepicker: 2,
  datepicker3: 2,
  fauxBlockLink: 2,
  sortCardGroup: 2,
  submittedTransactionTable: 2,
  tileButtonOverlay: 2,
  root: 1,
  sub: -1
};
var context = typeof global !== 'undefined' ? global : {};

var _createEmotion = createEmotion(context, {
  nonce: btoa('web-ui-components')
}),
    caches = _createEmotion.caches,
    css = _createEmotion.css,
    cx = _createEmotion.cx,
    flush = _createEmotion.flush,
    getRegisteredStyles = _createEmotion.getRegisteredStyles,
    hydrate = _createEmotion.hydrate,
    injectGlobal = _createEmotion.injectGlobal,
    keyframes = _createEmotion.keyframes,
    merge = _createEmotion.merge,
    sheet = _createEmotion.sheet;

var emotion = /*#__PURE__*/Object.freeze({
  __proto__: null,
  caches: caches,
  css: css,
  cx: cx,
  flush: flush,
  getRegisteredStyles: getRegisteredStyles,
  hydrate: hydrate,
  injectGlobal: injectGlobal,
  keyframes: keyframes,
  merge: merge,
  sheet: sheet
});
var styled = createEmotionStyled(emotion, React);

var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var defineProperty = function defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var taggedTemplateLiteral = function taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

var hslAdjust = function hslAdjust(hslText) {
  var splitHSL = hslText.slice(4, hslText.length - 1).split(',');

  var _splitHSL = slicedToArray(splitHSL, 3),
      hueLabel = _splitHSL[0],
      saturationLabel = _splitHSL[1],
      lightnessLabel = _splitHSL[2];

  var hue = parseInt(hueLabel, 10);
  var saturation = parseInt(saturationLabel.slice(0, saturationLabel.length - 1), 10);
  var lightness = parseInt(lightnessLabel.slice(0, lightnessLabel.length - 1), 10);
  return {
    darken: function darken() {
      var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
      return 'hsl(' + hue + ', ' + saturation + '%, ' + (lightness - amount) + '%)';
    },
    lighten: function lighten() {
      var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
      return 'hsl(' + hue + ', ' + saturation + '%, ' + (lightness + amount) + '%)';
    },
    saturate: function saturate() {
      var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
      return 'hsl(' + hue + ', ' + (saturation + amount) + '%, ' + lightness + '%)';
    },
    desaturate: function desaturate() {
      var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
      return 'hsl(' + hue + ', ' + (saturation - amount) + '%, ' + lightness + '%)';
    }
  };
};

var _templateObject = taggedTemplateLiteral(['\n  0% {\n    box-shadow: 0 0 0 0 rgba(121, 0, 202, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(121, 0, 202, 0);\n  }\n'], ['\n  0% {\n    box-shadow: 0 0 0 0 rgba(121, 0, 202, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(121, 0, 202, 0);\n  }\n']),
    _templateObject2 = taggedTemplateLiteral(['\n  0% {\n    box-shadow: 0 0 0 0 rgba(248, 0, 0, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(248, 0, 0, 0);\n  }\n'], ['\n  0% {\n    box-shadow: 0 0 0 0 rgba(248, 0, 0, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(248, 0, 0, 0);\n  }\n']),
    _templateObject3 = taggedTemplateLiteral(['\n  0% {\n    box-shadow: 0 0 0 0 rgba(0, 148, 211, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(0, 148, 211, 0);\n  }\n'], ['\n  0% {\n    box-shadow: 0 0 0 0 rgba(0, 148, 211, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(0, 148, 211, 0);\n  }\n']),
    _templateObject4 = taggedTemplateLiteral(['\n  0% {\n    opacity: 0;\n  }\n  25% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n'], ['\n  0% {\n    opacity: 0;\n  }\n  25% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n']),
    _templateObject5 = taggedTemplateLiteral(['\n  0% {\n    opacity: 1;\n  }\n  25% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 0;\n  }\n'], ['\n  0% {\n    opacity: 1;\n  }\n  25% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 0;\n  }\n']),
    _templateObject6 = taggedTemplateLiteral(['\n  from {\n    fill: ', ';\n  }\n  to {\n    fill: ', ';\n  }\n'], ['\n  from {\n    fill: ', ';\n  }\n  to {\n    fill: ', ';\n  }\n']),
    _templateObject7 = taggedTemplateLiteral(['\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n'], ['\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n']),
    _templateObject8 = taggedTemplateLiteral(['\n  0% {\n    transform: scale(0.8);\n  }\n  65.5% {\n    transform: scale(1.03);\n  }\n  100% {\n    transform: scale(1);\n  }\n'], ['\n  0% {\n    transform: scale(0.8);\n  }\n  65.5% {\n    transform: scale(1.03);\n  }\n  100% {\n    transform: scale(1);\n  }\n']);

var circularPulseB = keyframes(_templateObject, spacing(4));
var circularPulseCB = keyframes(_templateObject2, spacing(4));
var circularPulseYB = keyframes(_templateObject3, spacing(4));
var fadeIn = keyframes(_templateObject4);
var fadeOut = keyframes(_templateObject5);

var iconPulse = function iconPulse(colour) {
  return keyframes(_templateObject6, colour, hslAdjust(colour).lighten(0.2));
};

var rotate = keyframes(_templateObject7);
var scaleFadeIn = keyframes(_templateObject8);
var animations = {
  circularPulseB: circularPulseB,
  circularPulseCB: circularPulseCB,
  circularPulseYB: circularPulseYB,
  fadeIn: fadeIn,
  fadeOut: fadeOut,
  iconPulse: iconPulse,
  rotate: rotate,
  scaleFadeIn: scaleFadeIn
};
var generalPalette = {
  black: 'hsl(0, 0%, 0%)',
  blue: 'hsl(204, 52%, 48%)',
  blueLight: 'hsl(208, 59%, 60%)',
  green: 'hsl(135, 41%, 48%)',
  greenFaint: 'hsl(135, 41%, 70%)',
  greyDarkest: 'hsl(0, 0%, 28%)',
  greyDarker: 'hsl(0, 0%, 42%)',
  grey: 'hsl(0, 0%, 60%)',
  greyLighter: 'hsl(0, 0%, 75%)',
  greyLightest: 'hsl(0, 0%, 85%)',
  orange: 'hsl(29, 77%, 56%)',
  red: 'hsl(8, 52%, 50%)',
  purple: 'hsl(282, 25%, 57%)',
  white: 'hsl(0, 0%, 100%)'
};
var black = generalPalette.black,
    blue = generalPalette.blue,
    blueLight = generalPalette.blueLight,
    green = generalPalette.green,
    greenFaint = generalPalette.greenFaint,
    greyDarker = generalPalette.greyDarker,
    greyDarkest = generalPalette.greyDarkest,
    greyLightest = generalPalette.greyLightest,
    orange = generalPalette.orange,
    red = generalPalette.red,
    grey = generalPalette.grey,
    greyLighter = generalPalette.greyLighter,
    purple = generalPalette.purple,
    white = generalPalette.white;
var colours = {
  backgrounds: {
    alternateBody: 'hsl(212, 100%, 97%)',
    alternateHeader: greyLightest,
    component: white,
    modalBackdrop: black,
    modalBackdropOpaque: 'rgba(0, 0, 0, 0.8)',
    shell: 'hsl(0, 0%, 95.3%)',
    tableCell: 'hsl(0, 0%, 97%)',
    tableCellAlternate: 'hsl(0, 71%, 97%)',
    tableCellHeader: 'hsl(0, 0%, 94%)'
  },
  component: {
    border: greyLightest,
    hover: greyLightest
  },
  disabled: {
    background: greyLightest,
    border: greyDarkest
  },
  neutral: {
    black: black,
    grey: grey,
    greyDarker: greyDarker,
    greyDarkest: greyDarkest,
    greyLighter: greyLighter,
    greyLightest: greyLightest,
    white: white
  },
  telephony: {
    answerCallGradient: 'linear-gradient(hsl(54, 100%, 73%), hsl(49, 99%, 64%));',
    calledGradient: 'linear-gradient(hsl(159, 52%, 67%), hsl(153, 41%, 49%));',
    conferenceCallGradient: 'linear-gradient(hsl(193, 100%, 91%), hsl(196, 96%, 80%));',
    conferenceMaskGradient: 'linear-gradient(hsl(248, 86%, 83%), hsl(260, 94%, 72%));',
    dialingCallGradient: 'linear-gradient(hsl(54, 100%, 73%), hsl(49, 99%, 64%));',
    holdCallGradient: 'linear-gradient(hsl(45, 95%, 75%), hsl(37, 91%, 65%));',
    makeCallGradient: 'linear-gradient(hsl(33, 15%, 86%), hsl(180, 3%, 69%));',
    onCallGradient: 'linear-gradient(hsl(129, 80%, 82%), hsl(127, 67%, 63%));',
    answerCall: 'hsl(89, 91%, 40%)',
    closeCall: 'hsl(353, 98%, 41%)',
    dialCall: 'hsl(89, 91%, 40%)',
    endCall: 'hsl(353, 98%, 41%)',
    holdCall: 'hsl(37, 94%, 49%)',
    resumeCall: 'hsl(89, 91%, 40%)'
  },
  typography: {
    body: greyDarkest,
    supplementaryBody: grey
  },
  utility: {
    active: green,
    archived: greyLightest,
    blocker: 'hsl(0, 60%, 96%)',
    deprecated: 'hsl(45, 100%, 51%)',
    empty: 'hsl(0, 0%, 100%)',
    emptyBorder: 'hsl(0, 0%, 40%)',
    error: red,
    errorBodyBackground: 'hsl(8,52%,96%)',
    focus: blueLight,
    help: 'hsl(210, 38%, 91%)',
    inactive: red,
    indicative: orange,
    information: blue,
    notStarted: greyDarker,
    off: grey,
    offDisabled: greyLighter,
    ongoing: purple,
    paused: blue,
    pending: orange,
    success: green,
    successDisabled: greenFaint,
    warning: orange
  },
  utilityLegacy: {
    infoBackground: 'hsl(210, 46%, 91%)',
    infoBorder: 'hsl(204, 52%, 48%)',
    noteBackground: 'hsl(45, 53%, 94%)',
    noteBorder: 'hsl(46, 88%, 24%)',
    tipBackground: 'hsl(125, 21%, 88%)',
    tipBorder: 'hsl(135, 41%, 48%)',
    warningBackground: 'hsl(0, 60%, 96%)',
    warningBorder: 'hsl(8, 52%, 50%)'
  }
};

var _templateObject$1 = taggedTemplateLiteral(['\n\tcolor: ', ';\n\t', '\n\tfont-family: ', ';\n\tmargin: 0;\n'], ['\n\tcolor: ', ';\n\t', '\n\tfont-family: ', ';\n\tmargin: 0;\n']),
    _templateObject2$1 = taggedTemplateLiteral(['\n\talign-items: center;\n\tdisplay: flex;\n\t', ';\n\t', ';\n\n\t> svg {\n\t\tfill: ', ';\n\t\theight: ', ';\n\t\tmargin-right: ', ';\n\t\twidth: ', ';\n\t}\n'], ['\n\talign-items: center;\n\tdisplay: flex;\n\t', ';\n\t', ';\n\n\t> svg {\n\t\tfill: ', ';\n\t\theight: ', ';\n\t\tmargin-right: ', ';\n\t\twidth: ', ';\n\t}\n']);

var getFontProperties = function getFontProperties(props) {
  var fontProperties = 'font-size: 25px; line-height: 1.32;'; // TODOxCYBG To be revisited with responsive VM typography.
  // if (props.theme.name !== 'vm') {

  fontProperties = props.theme.isCompact ? fontSize('arran') : fontSize('islay'); // }

  return fontProperties;
};

var StyledSubHeading = styled('h2')(_templateObject$1, function (props) {
  return props.theme.colours.heading;
}, getFontProperties, function (props) {
  return props.theme.fonts.display.bold;
});
var StyledWrapper = styled('div')(_templateObject2$1, function (props) {
  return props.isFlush ? 'margin-bottom: 0' : 'margin-bottom: ' + spacing(2);
}, function (props) {
  return !props.isFlush && 'margin-right: ' + spacing(2);
}, function (props) {
  return props.theme.colours.heading;
}, function (props) {
  return props.theme.isCompact ? '14px' : '28px';
}, function (props) {
  return props.theme.isCompact ? '8px' : '16px';
}, function (props) {
  return props.theme.isCompact ? '14px' : '28px';
});
/**
 * Uses `<h2>` tag internally.
 * @example ./Design.md
 */

var SubHeading = function SubHeading(_ref) {
  var children = _ref.children,
      icon = _ref.icon,
      isFlush = _ref.isFlush;
  return React.createElement(StyledWrapper, {
    isFlush: isFlush
  }, icon, React.createElement(StyledSubHeading, null, children));
};

SubHeading.propTypes = {
  /** Allows for content to be text or node (for example IconTextDynamic). */
  children: PropTypes.node.isRequired,

  /** Optional Left aligned icon with SubHeading. */
  icon: PropTypes.node,

  /** Removed margins. */
  isFlush: PropTypes.bool
};
SubHeading.defaultProps = {
  isFlush: false
};

var _templateObject$2 = taggedTemplateLiteral(['\n\talign-items: flex-start;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\n\t> h2 {\n\t\tmargin-right: 8px;\n\t}\n'], ['\n\talign-items: flex-start;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\n\t> h2 {\n\t\tmargin-right: 8px;\n\t}\n']),
    _templateObject2$2 = taggedTemplateLiteral(['\n\tcolor: ', ';\n\ttext-decoration: underline;\n'], ['\n\tcolor: ', ';\n\ttext-decoration: underline;\n']);

var StyledHeader = styled('div')(_templateObject$2);
var StyledButton = styled('button')(_templateObject2$2, function (props) {
  return props.theme.colours.primary;
});

var ModalHeader = function ModalHeader(_ref) {
  var title = _ref.title,
      onClick = _ref.onClick;
  return React.createElement(StyledHeader, null, React.createElement(SubHeading, null, title), React.createElement(StyledButton, {
    onClick: onClick,
    type: 'button'
  }, 'Close'));
};

ModalHeader.propTypes = {
  /** Modal headers title string */
  title: PropTypes.string,

  /** onClick callback function */
  onClick: PropTypes.func
};

var ModalBody = function ModalBody(_ref) {
  var children = _ref.children;
  return React.createElement('div', {
    className: 'modal-body'
  }, children);
};

ModalBody.propTypes = {
  children: PropTypes.node
};

var ModalFooter = function ModalFooter(_ref) {
  var children = _ref.children;
  return React.createElement('div', null, children);
};

ModalFooter.propTypes = {
  children: PropTypes.node.isRequired
};

var _templateObject$3 = taggedTemplateLiteral(['\n\tbackground-color: ', ';\n\tborder-radius: ', ';\n\tdisplay: flex;\n\tflex-direction: column;\n\toverflow: hidden;\n\tpadding: ', ';\n\tposition: relative;\n'], ['\n\tbackground-color: ', ';\n\tborder-radius: ', ';\n\tdisplay: flex;\n\tflex-direction: column;\n\toverflow: hidden;\n\tpadding: ', ';\n\tposition: relative;\n']),
    _templateObject2$3 = taggedTemplateLiteral(['\n\tbackground-color: ', ';\n\tbottom: 0;\n\tleft: 0;\n\tposition: fixed;\n\topacity: 0.7;\n\tright: 0;\n\ttop: 0;\n\tz-index: ', ';\n'], ['\n\tbackground-color: ', ';\n\tbottom: 0;\n\tleft: 0;\n\tposition: fixed;\n\topacity: 0.7;\n\tright: 0;\n\ttop: 0;\n\tz-index: ', ';\n']),
    _templateObject3$1 = taggedTemplateLiteral(['\n\tcolor: ', ';\n\tpadding: ', ' ', ' ', ' ', ';\n\t', ';\n'], ['\n\tcolor: ', ';\n\tpadding: ', ' ', ' ', ' ', ';\n\t', ';\n']),
    _templateObject4$1 = taggedTemplateLiteral(['\n\tmargin: auto;\n\tmax-width: ', ';\n'], ['\n\tmargin: auto;\n\tmax-width: ', ';\n']);

var StyledModalContent = styled('div')(_templateObject$3, colours.backgrounds.component, function (props) {
  return props.theme.borderRadiusLargest;
}, function (props) {
  return props.theme.name === 'vm' ? '24px' : '16px';
});
var StyledModalBackdrop = styled('div')(_templateObject2$3, colours.backgrounds.modalBackdrop, layers.sub);
var StyledDialogContainer = styled('div')(_templateObject3$1, function (props) {
  return props.theme.colours.bodyText;
}, spacing(4), spacing(2), spacing(2), spacing(2), function (props) {
  return props.hasCentredContent && 'text-align: center;';
});
var StyledDialog = styled('div')(_templateObject4$1, spacing(72.5));

var ModalContainer = function ModalContainer(_ref) {
  var children = _ref.children,
      hasCentredContent = _ref.hasCentredContent;
  return React.createElement(StyledDialogContainer, {
    hasCentredContent: hasCentredContent
  }, React.createElement(StyledDialog, null, React.createElement(StyledModalContent, null, children)), React.createElement(StyledModalBackdrop, null));
};

ModalContainer.propTypes = {
  /** Child node */
  children: PropTypes.node,

  /** Boolean controlling whether modal content is centred, defaulting to false. */
  hasCentredContent: PropTypes.bool
};
ModalContainer.defaultProps = {
  hasCentredContent: false
};

var _templateObject$4 = taggedTemplateLiteral(['\n\toverflow: hidden;\n'], ['\n\toverflow: hidden;\n']),
    _templateObject2$4 = taggedTemplateLiteral(['\n\tposition: fixed;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\tleft: 0;\n\tz-index: ', ';\n\tdisplay: none;\n\toverflow-x: hidden;\n\toverflow-y: scroll;\n\toutline: 0;\n\t&.show {\n\t\tdisplay: block;\n\t\topacity: 1;\n\t}\n'], ['\n\tposition: fixed;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\tleft: 0;\n\tz-index: ', ';\n\tdisplay: none;\n\toverflow-x: hidden;\n\toverflow-y: scroll;\n\toutline: 0;\n\t&.show {\n\t\tdisplay: block;\n\t\topacity: 1;\n\t}\n']);

var modalOpenBodyStyles = css(_templateObject$4);
var modalStyles = css(_templateObject2$4, layers.modal1);
var removeDefaultClasses = {
  base: '',
  afterOpen: '',
  beforeClose: ''
};

var BaseModal = function BaseModal(_ref) {
  var title = _ref.title,
      children = _ref.children,
      hasCentredContent = _ref.hasCentredContent,
      isOpen = _ref.isOpen,
      onAfterOpen = _ref.onAfterOpen,
      footerContent = _ref.footerContent,
      onClose = _ref.onClose;
  return React.createElement(ReactModal, {
    appElement: document.body,
    contentLabel: 'Modal',
    closeTimeoutMS: 300,
    isOpen: isOpen,
    onRequestClose: onClose,
    onAfterOpen: onAfterOpen,
    className: _extends({}, removeDefaultClasses, {
      base: 'react-modal__dialog'
    }),
    bodyOpenClassName: modalOpenBodyStyles,
    overlayClassName: {
      base: modalStyles,
      afterOpen: 'show',
      beforeClose: 'hide'
    },
    style: {
      overlay: {
        display: 'block'
      },
      content: {
        outline: 'none'
      }
    }
  }, React.createElement(ModalContainer, {
    hasCentredContent: hasCentredContent
  }, React.createElement(ModalHeader, {
    title: title,
    onClick: onClose
  }), React.createElement(ModalBody, {
    scrollable: true
  }, children), React.createElement(ModalFooter, null, footerContent)));
};

BaseModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  footerContent: PropTypes.node.isRequired,

  /** Boolean indicating whether the modal content should be centred or not, defaulting to false. */
  hasCentredContent: PropTypes.bool,
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func,
  onAfterOpen: PropTypes.func
};
BaseModal.defaultProps = {
  hasCentredContent: false
};
var componentPaths = [{
  name: "ActionButton",
  path: "actions/buttons/ActionButton",
  styleguidePath: "Actions/Buttons/ActionButton",
  importPath: "web-ui-components/lib/actions/buttons"
}, {
  name: "EmailLink",
  path: "actions/links/EmailLink",
  styleguidePath: "Actions/Links/EmailLink",
  importPath: "web-ui-components/lib/actions/links"
}, {
  name: "PhoneLink",
  path: "actions/links/PhoneLink",
  styleguidePath: "Actions/Links/PhoneLink",
  importPath: "web-ui-components/lib/actions/links"
}, {
  name: "WebsiteLink",
  path: "actions/links/WebsiteLink",
  styleguidePath: "Actions/Links/WebsiteLink",
  importPath: "web-ui-components/lib/actions/links"
}, {
  name: "InputRadio",
  path: "actions/radios/InputRadio",
  styleguidePath: "Actions/Radios/InputRadio",
  importPath: "web-ui-components/lib/actions/radios"
}, {
  name: "InputRadioGroup",
  path: "actions/radios/InputRadioGroup",
  styleguidePath: "Actions/Radios/InputRadioGroup",
  importPath: "web-ui-components/lib/actions/radios"
}, {
  name: "TallRadioCard",
  path: "actions/radios/TallRadioCard",
  styleguidePath: "Actions/Radios/TallRadioCard",
  importPath: "web-ui-components/lib/actions/radios"
}, {
  name: "WideRadioCard",
  path: "actions/radios/WideRadioCard",
  styleguidePath: "Actions/Radios/WideRadioCard",
  importPath: "web-ui-components/lib/actions/radios"
}, {
  name: "NewWindowAction",
  path: "advisor/actions/NewWindowAction",
  styleguidePath: "Advisor/Actions/NewWindowAction",
  importPath: "web-ui-components/lib/advisor/actions"
}, {
  name: "CustomerAlert",
  path: "advisor/alerts/CustomerAlert",
  styleguidePath: "Advisor/Alerts/CustomerAlert",
  importPath: "web-ui-components/lib/advisor/alerts"
}, {
  name: "DashboardGrid",
  path: "advisor/layout/DashboardGrid",
  styleguidePath: "Advisor/Layout/DashboardGrid",
  importPath: "web-ui-components/lib/advisor/layout"
}, {
  name: "WideModal",
  path: "advisor/layout/WideModal",
  styleguidePath: "Advisor/Layout/WideModal",
  importPath: "web-ui-components/lib/advisor/layout"
}, {
  name: "WindowFrame",
  path: "advisor/layout/WindowFrame",
  styleguidePath: "Advisor/Layout/WindowFrame",
  importPath: "web-ui-components/lib/advisor/layout"
}, {
  name: "AccountSelect",
  path: "advisor/selects/AccountSelect",
  styleguidePath: "Advisor/Selects/AccountSelect",
  importPath: "web-ui-components/lib/advisor/selects"
}, {
  name: "Anchor",
  path: "atoms/buttons/Anchor",
  styleguidePath: "Atoms/Buttons/Anchor",
  importPath: "web-ui-components/lib/atoms/buttons"
}, {
  name: "Button",
  path: "atoms/buttons/Button",
  styleguidePath: "Atoms/Buttons/Button",
  importPath: "web-ui-components/lib/atoms/buttons"
}, {
  name: "ButtonTitle",
  path: "atoms/buttons/ButtonTitle",
  styleguidePath: "Atoms/Buttons/ButtonTitle",
  importPath: "web-ui-components/lib/atoms/buttons"
}, {
  name: "Calendar",
  path: "atoms/forms/Calendar",
  styleguidePath: "Atoms/Forms/Calendar",
  importPath: "web-ui-components/lib/atoms/forms"
}, {
  name: "Checkbox",
  path: "atoms/forms/Checkbox",
  styleguidePath: "Atoms/Forms/Checkbox",
  importPath: "web-ui-components/lib/atoms/forms"
}, {
  name: "CheckboxToggle",
  path: "atoms/forms/CheckboxToggle",
  styleguidePath: "Atoms/Forms/CheckboxToggle",
  importPath: "web-ui-components/lib/atoms/forms"
}, {
  name: "Datepicker",
  path: "atoms/forms/Datepicker",
  styleguidePath: "Atoms/Forms/Datepicker",
  importPath: "web-ui-components/lib/atoms/forms"
}, {
  name: "FieldDescription",
  path: "atoms/forms/FieldDescription",
  styleguidePath: "Atoms/Forms/FieldDescription",
  importPath: "web-ui-components/lib/atoms/forms"
}, {
  name: "Input",
  path: "atoms/forms/Input/Input",
  styleguidePath: "Atoms/Forms/Input/Input",
  importPath: "web-ui-components/lib/atoms/forms/input"
}, {
  name: "Prefix",
  path: "atoms/forms/Input/Prefix",
  styleguidePath: "Atoms/Forms/Input/Prefix",
  importPath: "web-ui-components/lib/atoms/forms/input"
}, {
  name: "Suffix",
  path: "atoms/forms/Input/Suffix",
  styleguidePath: "Atoms/Forms/Input/Suffix",
  importPath: "web-ui-components/lib/atoms/forms/input"
}, {
  name: "TextPrompt",
  path: "atoms/forms/Input/TextPrompt",
  styleguidePath: "Atoms/Forms/Input/TextPrompt",
  importPath: "web-ui-components/lib/atoms/forms/input"
}, {
  name: "InputClickable",
  path: "atoms/forms/InputClickable",
  styleguidePath: "Atoms/Forms/InputClickable",
  importPath: "web-ui-components/lib/atoms/forms"
}, {
  name: "InputRange",
  path: "atoms/forms/InputRange",
  styleguidePath: "Atoms/Forms/InputRange",
  importPath: "web-ui-components/lib/atoms/forms"
}, {
  name: "LabelTitle",
  path: "atoms/forms/Label/LabelTitle",
  styleguidePath: "Atoms/Forms/Label/LabelTitle",
  importPath: "web-ui-components/lib/atoms/forms/label"
}, {
  name: "Label",
  path: "atoms/forms/Label",
  styleguidePath: "Atoms/Forms/Label",
  importPath: "web-ui-components/lib/atoms/forms"
}, {
  name: "MediaCheckbox",
  path: "atoms/forms/MediaCheckbox",
  styleguidePath: "Atoms/Forms/MediaCheckbox",
  importPath: "web-ui-components/lib/atoms/forms"
}, {
  name: "MediaRadio",
  path: "atoms/forms/MediaRadio",
  styleguidePath: "Atoms/Forms/MediaRadio",
  importPath: "web-ui-components/lib/atoms/forms"
}, {
  name: "MultiSelect",
  path: "atoms/forms/MultiSelect",
  styleguidePath: "Atoms/Forms/MultiSelect",
  importPath: "web-ui-components/lib/atoms/forms"
}, {
  name: "Radio",
  path: "atoms/forms/Radio",
  styleguidePath: "Atoms/Forms/Radio",
  importPath: "web-ui-components/lib/atoms/forms"
}, {
  name: "RadioCard",
  path: "atoms/forms/RadioCard",
  styleguidePath: "Atoms/Forms/RadioCard",
  importPath: "web-ui-components/lib/atoms/forms"
}, {
  name: "Select",
  path: "atoms/forms/Select",
  styleguidePath: "Atoms/Forms/Select",
  importPath: "web-ui-components/lib/atoms/forms"
}, {
  name: "Textarea",
  path: "atoms/forms/Textarea",
  styleguidePath: "Atoms/Forms/Textarea",
  importPath: "web-ui-components/lib/atoms/forms"
}, {
  name: "TextAreaCharacterCount",
  path: "atoms/forms/TextAreaCharacterCount",
  styleguidePath: "Atoms/Forms/TextAreaCharacterCount",
  importPath: "web-ui-components/lib/atoms/forms"
}, {
  name: "TimeEstimationIcon",
  path: "atoms/forms/TimeEstimationIcon",
  styleguidePath: "Atoms/Forms/TimeEstimationIcon",
  importPath: "web-ui-components/lib/atoms/forms"
}, {
  name: "AnimatedIcon",
  path: "atoms/iconography/AnimatedIcon",
  styleguidePath: "Atoms/Iconography/AnimatedIcon",
  importPath: "web-ui-components/lib/atoms/iconography"
}, {
  name: "DistinctiveGeneratedSymbol",
  path: "atoms/iconography/DistinctiveGeneratedSymbol",
  styleguidePath: "Atoms/Iconography/DistinctiveGeneratedSymbol",
  importPath: "web-ui-components/lib/atoms/iconography"
}, {
  name: "Icon",
  path: "atoms/iconography/Icon",
  styleguidePath: "Atoms/Iconography/Icon",
  importPath: "web-ui-components/lib/atoms/iconography"
}, {
  name: "Divider",
  path: "atoms/layout/Divider",
  styleguidePath: "Atoms/Layout/Divider",
  importPath: "web-ui-components/lib/atoms/layout"
}, {
  name: "UploadPreviewContainer",
  path: "atoms/layout/UploadPreviewContainer",
  styleguidePath: "Atoms/Layout/UploadPreviewContainer",
  importPath: "web-ui-components/lib/atoms/layout"
}, {
  name: "AndroidStoreLogo",
  path: "atoms/logo/AndroidStoreLogo",
  styleguidePath: "Atoms/Logo/AndroidStoreLogo",
  importPath: "web-ui-components/lib/atoms/logo"
}, {
  name: "AppleStoreLogo",
  path: "atoms/logo/AppleStoreLogo",
  styleguidePath: "Atoms/Logo/AppleStoreLogo",
  importPath: "web-ui-components/lib/atoms/logo"
}, {
  name: "BankHeader",
  path: "atoms/logo/BankHeader",
  styleguidePath: "Atoms/Logo/BankHeader",
  importPath: "web-ui-components/lib/atoms/logo"
}, {
  name: "BLogo",
  path: "atoms/logo/BLogo",
  styleguidePath: "Atoms/Logo/BLogo",
  importPath: "web-ui-components/lib/atoms/logo"
}, {
  name: "BLogoCircular",
  path: "atoms/logo/BLogoCircular",
  styleguidePath: "Atoms/Logo/BLogoCircular",
  importPath: "web-ui-components/lib/atoms/logo"
}, {
  name: "CBLogo",
  path: "atoms/logo/CBLogo",
  styleguidePath: "Atoms/Logo/CBLogo",
  importPath: "web-ui-components/lib/atoms/logo"
}, {
  name: "CBLogoCircular",
  path: "atoms/logo/CBLogoCircular",
  styleguidePath: "Atoms/Logo/CBLogoCircular",
  importPath: "web-ui-components/lib/atoms/logo"
}, {
  name: "Header",
  path: "atoms/logo/Header",
  styleguidePath: "Atoms/Logo/Header",
  importPath: "web-ui-components/lib/atoms/logo"
}, {
  name: "SwitchGuaranteeLogo",
  path: "atoms/logo/SwitchGuaranteeLogo",
  styleguidePath: "Atoms/Logo/SwitchGuaranteeLogo",
  importPath: "web-ui-components/lib/atoms/logo"
}, {
  name: "VMSecondaryRedLogo",
  path: "atoms/logo/VMSecondaryRedLogo",
  styleguidePath: "Atoms/Logo/VMSecondaryRedLogo",
  importPath: "web-ui-components/lib/atoms/logo"
}, {
  name: "YBLogo",
  path: "atoms/logo/YBLogo",
  styleguidePath: "Atoms/Logo/YBLogo",
  importPath: "web-ui-components/lib/atoms/logo"
}, {
  name: "YBLogoCircular",
  path: "atoms/logo/YBLogoCircular",
  styleguidePath: "Atoms/Logo/YBLogoCircular",
  importPath: "web-ui-components/lib/atoms/logo"
}, {
  name: "Popover",
  path: "atoms/popovers/Popover",
  styleguidePath: "Atoms/Popovers/Popover",
  importPath: "web-ui-components/lib/atoms/popovers"
}, {
  name: "IdentityProcessingSignal",
  path: "atoms/signals/IdentityProcessingSignal",
  styleguidePath: "Atoms/Signals/IdentityProcessingSignal",
  importPath: "web-ui-components/lib/atoms/signals"
}, {
  name: "UploadProcessingSignal",
  path: "atoms/signals/UploadProcessingSignal",
  styleguidePath: "Atoms/Signals/UploadProcessingSignal",
  importPath: "web-ui-components/lib/atoms/signals"
}, {
  name: "BadgeLabel",
  path: "atoms/text/BadgeLabel",
  styleguidePath: "Atoms/Text/BadgeLabel",
  importPath: "web-ui-components/lib/atoms/text"
}, {
  name: "BulletedList",
  path: "atoms/text/BulletedList",
  styleguidePath: "Atoms/Text/BulletedList",
  importPath: "web-ui-components/lib/atoms/text"
}, {
  name: "Callout",
  path: "atoms/text/Callout",
  styleguidePath: "Atoms/Text/Callout",
  importPath: "web-ui-components/lib/atoms/text"
}, {
  name: "List",
  path: "atoms/text/List",
  styleguidePath: "Atoms/Text/List",
  importPath: "web-ui-components/lib/atoms/text"
}, {
  name: "NumberedList",
  path: "atoms/text/NumberedList",
  styleguidePath: "Atoms/Text/NumberedList",
  importPath: "web-ui-components/lib/atoms/text"
}, {
  name: "StatusBadge",
  path: "atoms/text/StatusBadge",
  styleguidePath: "Atoms/Text/StatusBadge",
  importPath: "web-ui-components/lib/atoms/text"
}, {
  name: "TextBody",
  path: "atoms/text/TextBody",
  styleguidePath: "Atoms/Text/TextBody",
  importPath: "web-ui-components/lib/atoms/text"
}, {
  name: "TextStyled",
  path: "atoms/text/TextStyled",
  styleguidePath: "Atoms/Text/TextStyled",
  importPath: "web-ui-components/lib/atoms/text"
}, {
  name: "TheSmallPrint",
  path: "atoms/text/TheSmallPrint",
  styleguidePath: "Atoms/Text/TheSmallPrint",
  importPath: "web-ui-components/lib/atoms/text"
}, {
  name: "Title",
  path: "atoms/text/Title",
  styleguidePath: "Atoms/Text/Title",
  importPath: "web-ui-components/lib/atoms/text"
}, {
  name: "TransitionBlock",
  path: "atoms/transitions/TransitionBlock",
  styleguidePath: "Atoms/Transitions/TransitionBlock",
  importPath: "web-ui-components/lib/atoms/transitions"
}, {
  name: "EmailInput",
  path: "communication/email/text-inputs/EmailInput",
  styleguidePath: "Communication/Email/Text-inputs/EmailInput",
  importPath: "web-ui-components/lib/communication/email/text-inputs"
}, {
  name: "Mail",
  path: "communication/messaging/Mail",
  styleguidePath: "Communication/Messaging/Mail",
  importPath: "web-ui-components/lib/communication/messaging"
}, {
  name: "Webchat",
  path: "communication/support/Webchat",
  styleguidePath: "Communication/Support/Webchat",
  importPath: "web-ui-components/lib/communication/support"
}, {
  name: "GenericCheckbox",
  path: "data/capture/checkboxes/GenericCheckbox",
  styleguidePath: "Data/Capture/Checkboxes/GenericCheckbox",
  importPath: "web-ui-components/lib/data/capture/checkboxes"
}, {
  name: "StandaloneCheckbox",
  path: "data/capture/checkboxes/StandaloneCheckbox",
  styleguidePath: "Data/Capture/Checkboxes/StandaloneCheckbox",
  importPath: "web-ui-components/lib/data/capture/checkboxes"
}, {
  name: "AccountNumberInput",
  path: "data/capture/inputs/AccountNumberInput",
  styleguidePath: "Data/Capture/Inputs/AccountNumberInput",
  importPath: "web-ui-components/lib/data/capture/inputs"
}, {
  name: "CurrencyInput",
  path: "data/capture/inputs/CurrencyInput",
  styleguidePath: "Data/Capture/Inputs/CurrencyInput",
  importPath: "web-ui-components/lib/data/capture/inputs"
}, {
  name: "DateOfBirthInput",
  path: "data/capture/inputs/DateOfBirthInput",
  styleguidePath: "Data/Capture/Inputs/DateOfBirthInput",
  importPath: "web-ui-components/lib/data/capture/inputs"
}, {
  name: "GenericTextInput",
  path: "data/capture/inputs/GenericTextInput",
  styleguidePath: "Data/Capture/Inputs/GenericTextInput",
  importPath: "web-ui-components/lib/data/capture/inputs"
}, {
  name: "LandlineNumberInput",
  path: "data/capture/inputs/LandlineNumberInput",
  styleguidePath: "Data/Capture/Inputs/LandlineNumberInput",
  importPath: "web-ui-components/lib/data/capture/inputs"
}, {
  name: "MonthAndYearDateInput",
  path: "data/capture/inputs/MonthAndYearDateInput",
  styleguidePath: "Data/Capture/Inputs/MonthAndYearDateInput",
  importPath: "web-ui-components/lib/data/capture/inputs"
}, {
  name: "SortcodeInput",
  path: "data/capture/inputs/SortcodeInput",
  styleguidePath: "Data/Capture/Inputs/SortcodeInput",
  importPath: "web-ui-components/lib/data/capture/inputs"
}, {
  name: "YearsAndMonthsCountInput",
  path: "data/capture/inputs/YearsAndMonthsCountInput",
  styleguidePath: "Data/Capture/Inputs/YearsAndMonthsCountInput",
  importPath: "web-ui-components/lib/data/capture/inputs"
}, {
  name: "DayOfMonthPicker",
  path: "data/capture/pickers/DayOfMonthPicker",
  styleguidePath: "Data/Capture/Pickers/DayOfMonthPicker",
  importPath: "web-ui-components/lib/data/capture/pickers"
}, {
  name: "FileProgressTakeover",
  path: "data/capture/progress/FileProgressTakeover",
  styleguidePath: "Data/Capture/Progress/FileProgressTakeover",
  importPath: "web-ui-components/lib/data/capture/progress"
}, {
  name: "GenericRadio",
  path: "data/capture/radios/GenericRadio",
  styleguidePath: "Data/Capture/Radios/GenericRadio",
  importPath: "web-ui-components/lib/data/capture/radios"
}, {
  name: "GenericSelect",
  path: "data/capture/selects/GenericSelect",
  styleguidePath: "Data/Capture/Selects/GenericSelect",
  importPath: "web-ui-components/lib/data/capture/selects"
}, {
  name: "GenericTextArea",
  path: "data/capture/text-areas/GenericTextArea",
  styleguidePath: "Data/Capture/Text-areas/GenericTextArea",
  importPath: "web-ui-components/lib/data/capture/text-areas"
}, {
  name: "GenericPaginatorNextButton",
  path: "data/filter-and-search/paginators/GenericPaginator/GenericPaginatorNextButton",
  styleguidePath: "Data/Filter-and-search/Paginators/GenericPaginator/GenericPaginatorNextButton",
  importPath: "web-ui-components/lib/data/filter-and-search/paginators/genericPaginator"
}, {
  name: "GenericPaginatorPreviousButton",
  path: "data/filter-and-search/paginators/GenericPaginator/GenericPaginatorPreviousButton",
  styleguidePath: "Data/Filter-and-search/Paginators/GenericPaginator/GenericPaginatorPreviousButton",
  importPath: "web-ui-components/lib/data/filter-and-search/paginators/genericPaginator"
}, {
  name: "GenericPaginator",
  path: "data/filter-and-search/paginators/GenericPaginator",
  styleguidePath: "Data/Filter-and-search/Paginators/GenericPaginator",
  importPath: "web-ui-components/lib/data/filter-and-search/paginators"
}, {
  name: "SearchTextInput",
  path: "data/filter-and-search/text-inputs/SearchTextInput",
  styleguidePath: "Data/Filter-and-search/Text-inputs/SearchTextInput",
  importPath: "web-ui-components/lib/data/filter-and-search/text-inputs"
}, {
  name: "GenericDescriptionList",
  path: "data/lists/description-lists/GenericDescriptionList",
  styleguidePath: "Data/Lists/Description-lists/GenericDescriptionList",
  importPath: "web-ui-components/lib/data/lists/description-lists"
}, {
  name: "NoResultsTile",
  path: "data/results/tiles/NoResultsTile",
  styleguidePath: "Data/Results/Tiles/NoResultsTile",
  importPath: "web-ui-components/lib/data/results/tiles"
}, {
  name: "DocumentLink",
  path: "documents/navigation/links/DocumentLink",
  styleguidePath: "Documents/Navigation/Links/DocumentLink",
  importPath: "web-ui-components/lib/documents/navigation/links"
}, {
  name: "DocumentLinkPlate",
  path: "documents/navigation/plates/DocumentLinkPlate",
  styleguidePath: "Documents/Navigation/Plates/DocumentLinkPlate",
  importPath: "web-ui-components/lib/documents/navigation/plates"
}, {
  name: "PrintButton",
  path: "documents/printing/buttons/PrintButton",
  styleguidePath: "Documents/Printing/Buttons/PrintButton",
  importPath: "web-ui-components/lib/documents/printing/buttons"
}, {
  name: "DocumentStatusBandCardAction",
  path: "documents/statuses/cards/DocumentStatusBandCard/DocumentStatusBandCardAction",
  styleguidePath: "Documents/Statuses/Cards/DocumentStatusBandCard/DocumentStatusBandCardAction",
  importPath: "web-ui-components/lib/documents/statuses/cards/documentStatusBandCard"
}, {
  name: "DocumentStatusBandCard",
  path: "documents/statuses/cards/DocumentStatusBandCard",
  styleguidePath: "Documents/Statuses/Cards/DocumentStatusBandCard",
  importPath: "web-ui-components/lib/documents/statuses/cards"
}, {
  name: "FileInput",
  path: "documents/upload/FileInput",
  styleguidePath: "Documents/Upload/FileInput",
  importPath: "web-ui-components/lib/documents/upload"
}, {
  name: "AccountCheckboxCard",
  path: "finance/accounts/cards/AccountCheckboxCard",
  styleguidePath: "Finance/Accounts/Cards/AccountCheckboxCard",
  importPath: "web-ui-components/lib/finance/accounts/cards"
}, {
  name: "AccountLegacyUpdateCard",
  path: "finance/accounts/cards/AccountLegacyUpdateCard",
  styleguidePath: "Finance/Accounts/Cards/AccountLegacyUpdateCard",
  importPath: "web-ui-components/lib/finance/accounts/cards"
}, {
  name: "AccountLinkCard",
  path: "finance/accounts/cards/AccountLinkCard",
  styleguidePath: "Finance/Accounts/Cards/AccountLinkCard",
  importPath: "web-ui-components/lib/finance/accounts/cards"
}, {
  name: "AccountSelectCard",
  path: "finance/accounts/cards/AccountSelectCard",
  styleguidePath: "Finance/Accounts/Cards/AccountSelectCard",
  importPath: "web-ui-components/lib/finance/accounts/cards"
}, {
  name: "AccountAuthorisationPanel",
  path: "finance/accounts/panels/AccountAuthorisationPanel",
  styleguidePath: "Finance/Accounts/Panels/AccountAuthorisationPanel",
  importPath: "web-ui-components/lib/finance/accounts/panels"
}, {
  name: "AccountBalancesSelectPanel",
  path: "finance/accounts/panels/AccountBalancesSelectPanel",
  styleguidePath: "Finance/Accounts/Panels/AccountBalancesSelectPanel",
  importPath: "web-ui-components/lib/finance/accounts/panels"
}, {
  name: "AccountLegacyPanel",
  path: "finance/accounts/panels/AccountLegacyPanel",
  styleguidePath: "Finance/Accounts/Panels/AccountLegacyPanel",
  importPath: "web-ui-components/lib/finance/accounts/panels"
}, {
  name: "AccountRadioCard",
  path: "finance/accounts/radios/AccountRadioCard",
  styleguidePath: "Finance/Accounts/Radios/AccountRadioCard",
  importPath: "web-ui-components/lib/finance/accounts/radios"
}, {
  name: "AccountPaymentReviewTable",
  path: "finance/accounts/tables/AccountPaymentReviewTable",
  styleguidePath: "Finance/Accounts/Tables/AccountPaymentReviewTable",
  importPath: "web-ui-components/lib/finance/accounts/tables"
}, {
  name: "AccountPaymentSubmittedTable",
  path: "finance/accounts/tables/AccountPaymentSubmittedTable",
  styleguidePath: "Finance/Accounts/Tables/AccountPaymentSubmittedTable",
  importPath: "web-ui-components/lib/finance/accounts/tables"
}, {
  name: "AccountPaymentTable",
  path: "finance/accounts/tables/AccountPaymentTable",
  styleguidePath: "Finance/Accounts/Tables/AccountPaymentTable",
  importPath: "web-ui-components/lib/finance/accounts/tables"
}, {
  name: "CurrencySelect",
  path: "finance/currency/selects/CurrencySelect",
  styleguidePath: "Finance/Currency/Selects/CurrencySelect",
  importPath: "web-ui-components/lib/finance/currency/selects"
}, {
  name: "FormInput",
  path: "forms/FormInput",
  styleguidePath: "Forms/FormInput",
  importPath: "web-ui-components/lib/forms"
}, {
  name: "BlockField",
  path: "global/layout/BlockField",
  styleguidePath: "Global/Layout/BlockField",
  importPath: "web-ui-components/lib/global/layout"
}, {
  name: "BlockFieldColumn",
  path: "global/layout/BlockFieldColumn",
  styleguidePath: "Global/Layout/BlockFieldColumn",
  importPath: "web-ui-components/lib/global/layout"
}, {
  name: "CenterImageContainer",
  path: "global/layout/CenterImageContainer",
  styleguidePath: "Global/Layout/CenterImageContainer",
  importPath: "web-ui-components/lib/global/layout"
}, {
  name: "Column",
  path: "global/layout/Column",
  styleguidePath: "Global/Layout/Column",
  importPath: "web-ui-components/lib/global/layout"
}, {
  name: "Container",
  path: "global/layout/Container",
  styleguidePath: "Global/Layout/Container",
  importPath: "web-ui-components/lib/global/layout"
}, {
  name: "FlexColumn",
  path: "global/layout/FlexColumn",
  styleguidePath: "Global/Layout/FlexColumn",
  importPath: "web-ui-components/lib/global/layout"
}, {
  name: "FlexRow",
  path: "global/layout/FlexRow",
  styleguidePath: "Global/Layout/FlexRow",
  importPath: "web-ui-components/lib/global/layout"
}, {
  name: "Frame",
  path: "global/layout/Frame",
  styleguidePath: "Global/Layout/Frame",
  importPath: "web-ui-components/lib/global/layout"
}, {
  name: "InternalSlot",
  path: "global/layout/InternalSlot",
  styleguidePath: "Global/Layout/InternalSlot",
  importPath: "web-ui-components/lib/global/layout"
}, {
  name: "LeftAndRightAlignment",
  path: "global/layout/LeftAndRightAlignment",
  styleguidePath: "Global/Layout/LeftAndRightAlignment",
  importPath: "web-ui-components/lib/global/layout"
}, {
  name: "PageLayout",
  path: "global/layout/PageLayout",
  styleguidePath: "Global/Layout/PageLayout",
  importPath: "web-ui-components/lib/global/layout"
}, {
  name: "HeaderSection",
  path: "global/layout/Pages/HeaderSection",
  styleguidePath: "Global/Layout/Pages/HeaderSection",
  importPath: "web-ui-components/lib/global/layout/pages"
}, {
  name: "ServicingSection",
  path: "global/layout/Pages/ServicingSection",
  styleguidePath: "Global/Layout/Pages/ServicingSection",
  importPath: "web-ui-components/lib/global/layout/pages"
}, {
  name: "WorkflowSection",
  path: "global/layout/Pages/WorkflowSection",
  styleguidePath: "Global/Layout/Pages/WorkflowSection",
  importPath: "web-ui-components/lib/global/layout/pages"
}, {
  name: "ResponsiveLayoutPair",
  path: "global/layout/ResponsiveLayoutPair",
  styleguidePath: "Global/Layout/ResponsiveLayoutPair",
  importPath: "web-ui-components/lib/global/layout"
}, {
  name: "Row",
  path: "global/layout/Row",
  styleguidePath: "Global/Layout/Row",
  importPath: "web-ui-components/lib/global/layout"
}, {
  name: "ContentContainer",
  path: "layout/containers/ContentContainer",
  styleguidePath: "Layout/Containers/ContentContainer",
  importPath: "web-ui-components/lib/layout/containers"
}, {
  name: "Main",
  path: "layout/containers/Main",
  styleguidePath: "Layout/Containers/Main",
  importPath: "web-ui-components/lib/layout/containers"
}, {
  name: "StatusBanner",
  path: "layout/content/banners/StatusBanner",
  styleguidePath: "Layout/Content/Banners/StatusBanner",
  importPath: "web-ui-components/lib/layout/content/banners"
}, {
  name: "GenericDivider",
  path: "layout/content/breaks/GenericDivider",
  styleguidePath: "Layout/Content/Breaks/GenericDivider",
  importPath: "web-ui-components/lib/layout/content/breaks"
}, {
  name: "MultiButtonModal",
  path: "layout/content/modals/MultiButtonModal",
  styleguidePath: "Layout/Content/Modals/MultiButtonModal",
  importPath: "web-ui-components/lib/layout/content/modals"
}, {
  name: "BrandedPanelHeader",
  path: "layout/content/panels/BrandedPanel/BrandedPanelHeader",
  styleguidePath: "Layout/Content/Panels/BrandedPanel/BrandedPanelHeader",
  importPath: "web-ui-components/lib/layout/content/panels/brandedPanel"
}, {
  name: "BrandedPanel",
  path: "layout/content/panels/BrandedPanel",
  styleguidePath: "Layout/Content/Panels/BrandedPanel",
  importPath: "web-ui-components/lib/layout/content/panels"
}, {
  name: "ConditionalPanel",
  path: "layout/content/panels/ConditionalPanel",
  styleguidePath: "Layout/Content/Panels/ConditionalPanel",
  importPath: "web-ui-components/lib/layout/content/panels"
}, {
  name: "ContentRevealPanel",
  path: "layout/content/panels/ContentRevealPanel",
  styleguidePath: "Layout/Content/Panels/ContentRevealPanel",
  importPath: "web-ui-components/lib/layout/content/panels"
}, {
  name: "InformationRevealPanel",
  path: "layout/content/panels/InformationRevealPanel",
  styleguidePath: "Layout/Content/Panels/InformationRevealPanel",
  importPath: "web-ui-components/lib/layout/content/panels"
}, {
  name: "SimplePanel",
  path: "layout/content/panels/SimplePanel",
  styleguidePath: "Layout/Content/Panels/SimplePanel",
  importPath: "web-ui-components/lib/layout/content/panels"
}, {
  name: "StatusPanel",
  path: "layout/content/panels/StatusPanel",
  styleguidePath: "Layout/Content/Panels/StatusPanel",
  importPath: "web-ui-components/lib/layout/content/panels"
}, {
  name: "ToggleButtonPanel",
  path: "layout/content/panels/ToggleButtonPanel",
  styleguidePath: "Layout/Content/Panels/ToggleButtonPanel",
  importPath: "web-ui-components/lib/layout/content/panels"
}, {
  name: "AttentionTile",
  path: "layout/content/tiles/AttentionTile",
  styleguidePath: "Layout/Content/Tiles/AttentionTile",
  importPath: "web-ui-components/lib/layout/content/tiles"
}, {
  name: "GuidanceTile",
  path: "layout/content/tiles/GuidanceTile",
  styleguidePath: "Layout/Content/Tiles/GuidanceTile",
  importPath: "web-ui-components/lib/layout/content/tiles"
}, {
  name: "RecapTile",
  path: "layout/content/tiles/RecapTile",
  styleguidePath: "Layout/Content/Tiles/RecapTile",
  importPath: "web-ui-components/lib/layout/content/tiles"
}, {
  name: "ValidationMessageTile",
  path: "layout/content/tiles/ValidationMessageTile",
  styleguidePath: "Layout/Content/Tiles/ValidationMessageTile",
  importPath: "web-ui-components/lib/layout/content/tiles"
}, {
  name: "GridViewToggle",
  path: "layout/content/views/GridViewToggle",
  styleguidePath: "Layout/Content/Views/GridViewToggle",
  importPath: "web-ui-components/lib/layout/content/views"
}, {
  name: "GenericFieldWrapper",
  path: "layout/fieldWrappers/GenericFieldWrapper",
  styleguidePath: "Layout/FieldWrappers/GenericFieldWrapper",
  importPath: "web-ui-components/lib/layout/fieldWrappers"
}, {
  name: "MainFixedFooter",
  path: "layout/footers/MainFixedFooter",
  styleguidePath: "Layout/Footers/MainFixedFooter",
  importPath: "web-ui-components/lib/layout/footers"
}, {
  name: "Grid",
  path: "layout/grids/Grid",
  styleguidePath: "Layout/Grids/Grid",
  importPath: "web-ui-components/lib/layout/grids"
}, {
  name: "ContainedHeader",
  path: "layout/headers/ContainedHeader",
  styleguidePath: "Layout/Headers/ContainedHeader",
  importPath: "web-ui-components/lib/layout/headers"
}, {
  name: "FixedFooter",
  path: "layout/sections/footers/FixedFooter",
  styleguidePath: "Layout/Sections/Footers/FixedFooter",
  importPath: "web-ui-components/lib/layout/sections/footers"
}, {
  name: "ApplicationFormShell",
  path: "layout/shells/ApplicationFormShell",
  styleguidePath: "Layout/Shells/ApplicationFormShell",
  importPath: "web-ui-components/lib/layout/shells"
}, {
  name: "DataManagementShell",
  path: "layout/shells/DataManagementShell",
  styleguidePath: "Layout/Shells/DataManagementShell",
  importPath: "web-ui-components/lib/layout/shells"
}, {
  name: "ShellInnerSpacer",
  path: "layout/shells/ShellInnerSpacer",
  styleguidePath: "Layout/Shells/ShellInnerSpacer",
  importPath: "web-ui-components/lib/layout/shells"
}, {
  name: "VerticalReviewTable",
  path: "layout/tables/VerticalReviewTable",
  styleguidePath: "Layout/Tables/VerticalReviewTable",
  importPath: "web-ui-components/lib/layout/tables"
}, {
  name: "NonUKAddressFieldset",
  path: "location/addresses/fieldsets/NonUKAddressFieldset",
  styleguidePath: "Location/Addresses/Fieldsets/NonUKAddressFieldset",
  importPath: "web-ui-components/lib/location/addresses/fieldsets"
}, {
  name: "UKAddressFieldset",
  path: "location/addresses/fieldsets/UKAddressFieldset",
  styleguidePath: "Location/Addresses/Fieldsets/UKAddressFieldset",
  importPath: "web-ui-components/lib/location/addresses/fieldsets"
}, {
  name: "UKAddressCaptureModule",
  path: "location/addresses/modules/UKAddressCaptureModule",
  styleguidePath: "Location/Addresses/Modules/UKAddressCaptureModule",
  importPath: "web-ui-components/lib/location/addresses/modules"
}, {
  name: "UKAddressCaptureModule2",
  path: "location/addresses/modules/UKAddressCaptureModule2",
  styleguidePath: "Location/Addresses/Modules/UKAddressCaptureModule2",
  importPath: "web-ui-components/lib/location/addresses/modules"
}, {
  name: "BaseSelect",
  path: "location/places/selects/BaseSelect",
  styleguidePath: "Location/Places/Selects/BaseSelect",
  importPath: "web-ui-components/lib/location/places/selects"
}, {
  name: "CountrySelect",
  path: "location/places/selects/CountrySelect",
  styleguidePath: "Location/Places/Selects/CountrySelect",
  importPath: "web-ui-components/lib/location/places/selects"
}, {
  name: "UKCitySelect",
  path: "location/places/selects/UKCitySelect",
  styleguidePath: "Location/Places/Selects/UKCitySelect",
  importPath: "web-ui-components/lib/location/places/selects"
}, {
  name: "AccordionItem",
  path: "molecules/accordions/Accordion/AccordionItem",
  styleguidePath: "Molecules/Accordions/Accordion/AccordionItem",
  importPath: "web-ui-components/lib/molecules/accordions/accordion"
}, {
  name: "Accordion",
  path: "molecules/accordions/Accordion",
  styleguidePath: "Molecules/Accordions/Accordion",
  importPath: "web-ui-components/lib/molecules/accordions"
}, {
  name: "AccordionTable",
  path: "molecules/accordions/AccordionTable",
  styleguidePath: "Molecules/Accordions/AccordionTable",
  importPath: "web-ui-components/lib/molecules/accordions"
}, {
  name: "ContentReveal",
  path: "molecules/accordions/ContentReveal",
  styleguidePath: "Molecules/Accordions/ContentReveal",
  importPath: "web-ui-components/lib/molecules/accordions"
}, {
  name: "ExpansionPanel",
  path: "molecules/accordions/ExpansionPanel",
  styleguidePath: "Molecules/Accordions/ExpansionPanel",
  importPath: "web-ui-components/lib/molecules/accordions"
}, {
  name: "ExpansionTable",
  path: "molecules/accordions/ExpansionTable",
  styleguidePath: "Molecules/Accordions/ExpansionTable",
  importPath: "web-ui-components/lib/molecules/accordions"
}, {
  name: "ButtonGroup",
  path: "molecules/buttons/ButtonGroup",
  styleguidePath: "Molecules/Buttons/ButtonGroup",
  importPath: "web-ui-components/lib/molecules/buttons"
}, {
  name: "SortingCardGroup",
  path: "molecules/card-groups/SortingCardGroup",
  styleguidePath: "Molecules/Card-groups/SortingCardGroup",
  importPath: "web-ui-components/lib/molecules/card-groups"
}, {
  name: "AccountCard",
  path: "molecules/cards/AccountCard",
  styleguidePath: "Molecules/Cards/AccountCard",
  importPath: "web-ui-components/lib/molecules/cards"
}, {
  name: "AccountSummaryLinkCard",
  path: "molecules/cards/AccountSummaryLinkCard",
  styleguidePath: "Molecules/Cards/AccountSummaryLinkCard",
  importPath: "web-ui-components/lib/molecules/cards"
}, {
  name: "DateCard",
  path: "molecules/cards/DateCard",
  styleguidePath: "Molecules/Cards/DateCard",
  importPath: "web-ui-components/lib/molecules/cards"
}, {
  name: "PromoCard",
  path: "molecules/cards/PromoCard",
  styleguidePath: "Molecules/Cards/PromoCard",
  importPath: "web-ui-components/lib/molecules/cards"
}, {
  name: "StackingCard",
  path: "molecules/cards/StackingCard",
  styleguidePath: "Molecules/Cards/StackingCard",
  importPath: "web-ui-components/lib/molecules/cards"
}, {
  name: "Autocomplete",
  path: "molecules/forms/Autocomplete",
  styleguidePath: "Molecules/Forms/Autocomplete",
  importPath: "web-ui-components/lib/molecules/forms"
}, {
  name: "ConfirmationCheckbox",
  path: "molecules/forms/ConfirmationCheckbox",
  styleguidePath: "Molecules/Forms/ConfirmationCheckbox",
  importPath: "web-ui-components/lib/molecules/forms"
}, {
  name: "DaySelector",
  path: "molecules/forms/DaySelector",
  styleguidePath: "Molecules/Forms/DaySelector",
  importPath: "web-ui-components/lib/molecules/forms"
}, {
  name: "FieldBody",
  path: "molecules/forms/Field/FieldBody",
  styleguidePath: "Molecules/Forms/Field/FieldBody",
  importPath: "web-ui-components/lib/molecules/forms/field"
}, {
  name: "FieldHeader",
  path: "molecules/forms/Field/FieldHeader",
  styleguidePath: "Molecules/Forms/Field/FieldHeader",
  importPath: "web-ui-components/lib/molecules/forms/field"
}, {
  name: "FormField",
  path: "molecules/forms/Field/FormField",
  styleguidePath: "Molecules/Forms/Field/FormField",
  importPath: "web-ui-components/lib/molecules/forms/field"
}, {
  name: "Field",
  path: "molecules/forms/Field",
  styleguidePath: "Molecules/Forms/Field",
  importPath: "web-ui-components/lib/molecules/forms"
}, {
  name: "PasswordReveal",
  path: "molecules/forms/PasswordReveal",
  styleguidePath: "Molecules/Forms/PasswordReveal",
  importPath: "web-ui-components/lib/molecules/forms"
}, {
  name: "RadioCardGroup",
  path: "molecules/forms/RadioCardGroup",
  styleguidePath: "Molecules/Forms/RadioCardGroup",
  importPath: "web-ui-components/lib/molecules/forms"
}, {
  name: "Search",
  path: "molecules/forms/Search",
  styleguidePath: "Molecules/Forms/Search",
  importPath: "web-ui-components/lib/molecules/forms"
}, {
  name: "SearchForm",
  path: "molecules/forms/SearchForm",
  styleguidePath: "Molecules/Forms/SearchForm",
  importPath: "web-ui-components/lib/molecules/forms"
}, {
  name: "SegmentedControl",
  path: "molecules/forms/SegmentedControl",
  styleguidePath: "Molecules/Forms/SegmentedControl",
  importPath: "web-ui-components/lib/molecules/forms"
}, {
  name: "SegmentedControlItem",
  path: "molecules/forms/SegmentedControl/SegmentedControlItem",
  styleguidePath: "Molecules/Forms/SegmentedControl/SegmentedControlItem",
  importPath: "web-ui-components/lib/molecules/forms/segmentedControl"
}, {
  name: "SegmentedSlider",
  path: "molecules/forms/SegmentedSlider",
  styleguidePath: "Molecules/Forms/SegmentedSlider",
  importPath: "web-ui-components/lib/molecules/forms"
}, {
  name: "TickMarks",
  path: "molecules/forms/SegmentedSlider/TickMarks",
  styleguidePath: "Molecules/Forms/SegmentedSlider/TickMarks",
  importPath: "web-ui-components/lib/molecules/forms/segmentedSlider"
}, {
  name: "ValidationMessage",
  path: "molecules/forms/ValidationMessage",
  styleguidePath: "Molecules/Forms/ValidationMessage",
  importPath: "web-ui-components/lib/molecules/forms"
}, {
  name: "IconTextDynamic",
  path: "molecules/icon-text-dynamic/IconTextDynamic",
  styleguidePath: "Molecules/Icon-text-dynamic/IconTextDynamic",
  importPath: "web-ui-components/lib/molecules/icon-text-dynamic"
}, {
  name: "IconText",
  path: "molecules/icon-text/IconText",
  styleguidePath: "Molecules/Icon-text/IconText",
  importPath: "web-ui-components/lib/molecules/icon-text"
}, {
  name: "BackAnchor",
  path: "molecules/navigation/BackAnchor",
  styleguidePath: "Molecules/Navigation/BackAnchor",
  importPath: "web-ui-components/lib/molecules/navigation"
}, {
  name: "BackButton",
  path: "molecules/navigation/BackButton",
  styleguidePath: "Molecules/Navigation/BackButton",
  importPath: "web-ui-components/lib/molecules/navigation"
}, {
  name: "Utility",
  path: "molecules/navigation/Utility",
  styleguidePath: "Molecules/Navigation/Utility",
  importPath: "web-ui-components/lib/molecules/navigation"
}, {
  name: "Alert",
  path: "molecules/nbas/Alert",
  styleguidePath: "Molecules/Nbas/Alert",
  importPath: "web-ui-components/lib/molecules/nbas"
}, {
  name: "Promo",
  path: "molecules/nbas/Promo",
  styleguidePath: "Molecules/Nbas/Promo",
  importPath: "web-ui-components/lib/molecules/nbas"
}, {
  name: "ContrastingFormPanel",
  path: "molecules/panels/ContrastingFormPanel",
  styleguidePath: "Molecules/Panels/ContrastingFormPanel",
  importPath: "web-ui-components/lib/molecules/panels"
}, {
  name: "DocumentAction",
  path: "molecules/panels/DocumentAction",
  styleguidePath: "Molecules/Panels/DocumentAction",
  importPath: "web-ui-components/lib/molecules/panels"
}, {
  name: "IconifiedBulletPoint",
  path: "molecules/panels/IconifiedBulletPoint",
  styleguidePath: "Molecules/Panels/IconifiedBulletPoint",
  importPath: "web-ui-components/lib/molecules/panels"
}, {
  name: "Panel",
  path: "molecules/panels/Panel",
  styleguidePath: "Molecules/Panels/Panel",
  importPath: "web-ui-components/lib/molecules/panels"
}, {
  name: "PanelBody",
  path: "molecules/panels/Panel/PanelBody",
  styleguidePath: "Molecules/Panels/Panel/PanelBody",
  importPath: "web-ui-components/lib/molecules/panels/panel"
}, {
  name: "PanelFooter",
  path: "molecules/panels/Panel/PanelFooter",
  styleguidePath: "Molecules/Panels/Panel/PanelFooter",
  importPath: "web-ui-components/lib/molecules/panels/panel"
}, {
  name: "PanelHeader",
  path: "molecules/panels/Panel/PanelHeader",
  styleguidePath: "Molecules/Panels/Panel/PanelHeader",
  importPath: "web-ui-components/lib/molecules/panels/panel"
}, {
  name: "PanelSector",
  path: "molecules/panels/Panel/PanelSector",
  styleguidePath: "Molecules/Panels/Panel/PanelSector",
  importPath: "web-ui-components/lib/molecules/panels/panel"
}, {
  name: "SettingLink",
  path: "molecules/panels/SettingLink",
  styleguidePath: "Molecules/Panels/SettingLink",
  importPath: "web-ui-components/lib/molecules/panels"
}, {
  name: "SubordinatePanel",
  path: "molecules/panels/SubordinatePanel",
  styleguidePath: "Molecules/Panels/SubordinatePanel",
  importPath: "web-ui-components/lib/molecules/panels"
}, {
  name: "TogglePanel",
  path: "molecules/panels/TogglePanel",
  styleguidePath: "Molecules/Panels/TogglePanel",
  importPath: "web-ui-components/lib/molecules/panels"
}, {
  name: "PaymentReview",
  path: "molecules/payments/PaymentReview",
  styleguidePath: "Molecules/Payments/PaymentReview",
  importPath: "web-ui-components/lib/molecules/payments"
}, {
  name: "ProgressIndicator",
  path: "molecules/progress/ProgressIndicator",
  styleguidePath: "Molecules/Progress/ProgressIndicator",
  importPath: "web-ui-components/lib/molecules/progress"
}, {
  name: "ProgressIndicatorItem",
  path: "molecules/progress/ProgressIndicator/ProgressIndicatorItem",
  styleguidePath: "Molecules/Progress/ProgressIndicator/ProgressIndicatorItem",
  importPath: "web-ui-components/lib/molecules/progress/progressIndicator"
}, {
  name: "ComparisonTable",
  path: "molecules/tables/ComparisonTable",
  styleguidePath: "Molecules/Tables/ComparisonTable",
  importPath: "web-ui-components/lib/molecules/tables"
}, {
  name: "DataTable",
  path: "molecules/tables/Table/DataTable",
  styleguidePath: "Molecules/Tables/Table/DataTable",
  importPath: "web-ui-components/lib/molecules/tables/table"
}, {
  name: "Table",
  path: "molecules/tables/Table/Table",
  styleguidePath: "Molecules/Tables/Table/Table",
  importPath: "web-ui-components/lib/molecules/tables/table"
}, {
  name: "TableBody",
  path: "molecules/tables/Table/TableBody",
  styleguidePath: "Molecules/Tables/Table/TableBody",
  importPath: "web-ui-components/lib/molecules/tables/table"
}, {
  name: "TableBodyData",
  path: "molecules/tables/Table/TableBodyData",
  styleguidePath: "Molecules/Tables/Table/TableBodyData",
  importPath: "web-ui-components/lib/molecules/tables/table"
}, {
  name: "TableHead",
  path: "molecules/tables/Table/TableHead",
  styleguidePath: "Molecules/Tables/Table/TableHead",
  importPath: "web-ui-components/lib/molecules/tables/table"
}, {
  name: "TableHeadData",
  path: "molecules/tables/Table/TableHeadData",
  styleguidePath: "Molecules/Tables/Table/TableHeadData",
  importPath: "web-ui-components/lib/molecules/tables/table"
}, {
  name: "TableRow",
  path: "molecules/tables/Table/TableRow",
  styleguidePath: "Molecules/Tables/Table/TableRow",
  importPath: "web-ui-components/lib/molecules/tables/table"
}, {
  name: "SectionHeading",
  path: "molecules/text/SectionHeading",
  styleguidePath: "Molecules/Text/SectionHeading",
  importPath: "web-ui-components/lib/molecules/text"
}, {
  name: "ConfirmationTile",
  path: "molecules/tile/ConfirmationTile",
  styleguidePath: "Molecules/Tile/ConfirmationTile",
  importPath: "web-ui-components/lib/molecules/tile"
}, {
  name: "ExclamationTile",
  path: "molecules/tile/ExclamationTile",
  styleguidePath: "Molecules/Tile/ExclamationTile",
  importPath: "web-ui-components/lib/molecules/tile"
}, {
  name: "HighlightTile",
  path: "molecules/tile/HighlightTile",
  styleguidePath: "Molecules/Tile/HighlightTile",
  importPath: "web-ui-components/lib/molecules/tile"
}, {
  name: "IconTile",
  path: "molecules/tile/IconTile",
  styleguidePath: "Molecules/Tile/IconTile",
  importPath: "web-ui-components/lib/molecules/tile"
}, {
  name: "NumberedTile",
  path: "molecules/tile/NumberedTile",
  styleguidePath: "Molecules/Tile/NumberedTile",
  importPath: "web-ui-components/lib/molecules/tile"
}, {
  name: "Tile",
  path: "molecules/tile/Tile",
  styleguidePath: "Molecules/Tile/Tile",
  importPath: "web-ui-components/lib/molecules/tile"
}, {
  name: "TileSector",
  path: "molecules/tile/Tile/TileSector",
  styleguidePath: "Molecules/Tile/Tile/TileSector",
  importPath: "web-ui-components/lib/molecules/tile/tile"
}, {
  name: "TileSegment",
  path: "molecules/tile/Tile/TileSegment",
  styleguidePath: "Molecules/Tile/Tile/TileSegment",
  importPath: "web-ui-components/lib/molecules/tile/tile"
}, {
  name: "ToggleOption",
  path: "molecules/toggle/ToggleOption",
  styleguidePath: "Molecules/Toggle/ToggleOption",
  importPath: "web-ui-components/lib/molecules/toggle"
}, {
  name: "NavigationButton",
  path: "navigation/buttons/NavigationButton",
  styleguidePath: "Navigation/Buttons/NavigationButton",
  importPath: "web-ui-components/lib/navigation/buttons"
}, {
  name: "NavigationButtonGroup",
  path: "navigation/buttons/NavigationButtonGroup",
  styleguidePath: "Navigation/Buttons/NavigationButtonGroup",
  importPath: "web-ui-components/lib/navigation/buttons"
}, {
  name: "MainNavLink",
  path: "navigation/nav-links/MainNavLink",
  styleguidePath: "Navigation/Nav-links/MainNavLink",
  importPath: "web-ui-components/lib/navigation/nav-links"
}, {
  name: "Paginator",
  path: "navigation/pagination/Paginator",
  styleguidePath: "Navigation/Pagination/Paginator",
  importPath: "web-ui-components/lib/navigation/pagination"
}, {
  name: "PaginatorNextButton",
  path: "navigation/pagination/Paginator/PaginatorNextButton",
  styleguidePath: "Navigation/Pagination/Paginator/PaginatorNextButton",
  importPath: "web-ui-components/lib/navigation/pagination/paginator"
}, {
  name: "PaginatorPageButton",
  path: "navigation/pagination/Paginator/PaginatorPageButton",
  styleguidePath: "Navigation/Pagination/Paginator/PaginatorPageButton",
  importPath: "web-ui-components/lib/navigation/pagination/paginator"
}, {
  name: "PaginatorPreviousButton",
  path: "navigation/pagination/Paginator/PaginatorPreviousButton",
  styleguidePath: "Navigation/Pagination/Paginator/PaginatorPreviousButton",
  importPath: "web-ui-components/lib/navigation/pagination/paginator"
}, {
  name: "MainSiteNav",
  path: "navigation/site-navs/MainSiteNav",
  styleguidePath: "Navigation/Site-navs/MainSiteNav",
  importPath: "web-ui-components/lib/navigation/site-navs"
}, {
  name: "MobileMainSiteNav",
  path: "navigation/site-navs/MobileMainSiteNav",
  styleguidePath: "Navigation/Site-navs/MobileMainSiteNav",
  importPath: "web-ui-components/lib/navigation/site-navs"
}, {
  name: "UtilityNav",
  path: "navigation/site-navs/UtilityNav",
  styleguidePath: "Navigation/Site-navs/UtilityNav",
  importPath: "web-ui-components/lib/navigation/site-navs"
}, {
  name: "TabCard",
  path: "navigation/tab-cards/TabCard",
  styleguidePath: "Navigation/Tab-cards/TabCard",
  importPath: "web-ui-components/lib/navigation/tab-cards"
}, {
  name: "TabCardBlock",
  path: "navigation/tab-cards/TabCardBlock",
  styleguidePath: "Navigation/Tab-cards/TabCardBlock",
  importPath: "web-ui-components/lib/navigation/tab-cards"
}, {
  name: "TabCardSmall",
  path: "navigation/tab-cards/TabCardSmall",
  styleguidePath: "Navigation/Tab-cards/TabCardSmall",
  importPath: "web-ui-components/lib/navigation/tab-cards"
}, {
  name: "TabGroup",
  path: "navigation/tab-group/TabGroup",
  styleguidePath: "Navigation/Tab-group/TabGroup",
  importPath: "web-ui-components/lib/navigation/tab-group"
}, {
  name: "TabButton",
  path: "navigation/tab-group/TabGroup/TabButton",
  styleguidePath: "Navigation/Tab-group/TabGroup/TabButton",
  importPath: "web-ui-components/lib/navigation/tab-group/tabGroup"
}, {
  name: "TransferTakeover",
  path: "navigation/takeovers/TransferTakeover",
  styleguidePath: "Navigation/Takeovers/TransferTakeover",
  importPath: "web-ui-components/lib/navigation/takeovers"
}, {
  name: "Card",
  path: "organisms/cards/Card",
  styleguidePath: "Organisms/Cards/Card",
  importPath: "web-ui-components/lib/organisms/cards"
}, {
  name: "DistinctiveLinkCard",
  path: "organisms/cards/DistinctiveLinkCard",
  styleguidePath: "Organisms/Cards/DistinctiveLinkCard",
  importPath: "web-ui-components/lib/organisms/cards"
}, {
  name: "FilterAction",
  path: "organisms/filters/Filter/FilterActionGroup/FilterAction",
  styleguidePath: "Organisms/Filters/Filter/FilterActionGroup/FilterAction",
  importPath: "web-ui-components/lib/organisms/filters/filter/filterActionGroup"
}, {
  name: "FilterActionGroup",
  path: "organisms/filters/Filter/FilterActionGroup",
  styleguidePath: "Organisms/Filters/Filter/FilterActionGroup",
  importPath: "web-ui-components/lib/organisms/filters/filter"
}, {
  name: "FilterSector",
  path: "organisms/filters/Filter/FilterSector",
  styleguidePath: "Organisms/Filters/Filter/FilterSector",
  importPath: "web-ui-components/lib/organisms/filters/filter"
}, {
  name: "FilterSegment",
  path: "organisms/filters/Filter/FilterSegmentGroup/FilterSegment",
  styleguidePath: "Organisms/Filters/Filter/FilterSegmentGroup/FilterSegment",
  importPath: "web-ui-components/lib/organisms/filters/filter/filterSegmentGroup"
}, {
  name: "FilterSegmentGroup",
  path: "organisms/filters/Filter/FilterSegmentGroup",
  styleguidePath: "Organisms/Filters/Filter/FilterSegmentGroup",
  importPath: "web-ui-components/lib/organisms/filters/filter"
}, {
  name: "FilterSubSegment",
  path: "organisms/filters/Filter/FilterSubSegmentGroup/FilterSubSegment",
  styleguidePath: "Organisms/Filters/Filter/FilterSubSegmentGroup/FilterSubSegment",
  importPath: "web-ui-components/lib/organisms/filters/filter/filterSubSegmentGroup"
}, {
  name: "FilterSubSegmentGroup",
  path: "organisms/filters/Filter/FilterSubSegmentGroup",
  styleguidePath: "Organisms/Filters/Filter/FilterSubSegmentGroup",
  importPath: "web-ui-components/lib/organisms/filters/filter"
}, {
  name: "Filter",
  path: "organisms/filters/Filter",
  styleguidePath: "Organisms/Filters/Filter",
  importPath: "web-ui-components/lib/organisms/filters"
}, {
  name: "GlobalHeader",
  path: "organisms/global/GlobalHeader",
  styleguidePath: "Organisms/Global/GlobalHeader",
  importPath: "web-ui-components/lib/organisms/global"
}, {
  name: "HeroHeader",
  path: "organisms/global/HeroHeader",
  styleguidePath: "Organisms/Global/HeroHeader",
  importPath: "web-ui-components/lib/organisms/global"
}, {
  name: "CentredModal",
  path: "organisms/modals/CentredModal",
  styleguidePath: "Organisms/Modals/CentredModal",
  importPath: "web-ui-components/lib/organisms/modals"
}, {
  name: "ConfirmationModal",
  path: "organisms/modals/ConfirmationModal",
  styleguidePath: "Organisms/Modals/ConfirmationModal",
  importPath: "web-ui-components/lib/organisms/modals"
}, {
  name: "Loader",
  path: "organisms/modals/Loader",
  styleguidePath: "Organisms/Modals/Loader",
  importPath: "web-ui-components/lib/organisms/modals"
}, {
  name: "ModalBody",
  path: "organisms/modals/Modal/ModalBody",
  styleguidePath: "Organisms/Modals/Modal/ModalBody",
  importPath: "web-ui-components/lib/organisms/modals/modal"
}, {
  name: "ModalContainer",
  path: "organisms/modals/Modal/ModalContainer",
  styleguidePath: "Organisms/Modals/Modal/ModalContainer",
  importPath: "web-ui-components/lib/organisms/modals/modal"
}, {
  name: "ModalHeader",
  path: "organisms/modals/Modal/ModalHeader",
  styleguidePath: "Organisms/Modals/Modal/ModalHeader",
  importPath: "web-ui-components/lib/organisms/modals/modal"
}, {
  name: "Modal",
  path: "organisms/modals/Modal",
  styleguidePath: "Organisms/Modals/Modal",
  importPath: "web-ui-components/lib/organisms/modals"
}, {
  name: "UnfinishedWorkModal",
  path: "organisms/modals/UnfinishedWorkModal",
  styleguidePath: "Organisms/Modals/UnfinishedWorkModal",
  importPath: "web-ui-components/lib/organisms/modals"
}, {
  name: "DisableTakeover",
  path: "organisms/takeovers/DisableTakeover",
  styleguidePath: "Organisms/Takeovers/DisableTakeover",
  importPath: "web-ui-components/lib/organisms/takeovers"
}, {
  name: "LoadingLocalTakeover",
  path: "organisms/takeovers/LoadingLocalTakeover",
  styleguidePath: "Organisms/Takeovers/LoadingLocalTakeover",
  importPath: "web-ui-components/lib/organisms/takeovers"
}, {
  name: "Timeline",
  path: "organisms/timelines/Timeline",
  styleguidePath: "Organisms/Timelines/Timeline",
  importPath: "web-ui-components/lib/organisms/timelines"
}, {
  name: "LoanReasonSelector",
  path: "products/selection/LoanReasonSelector",
  styleguidePath: "Products/Selection/LoanReasonSelector",
  importPath: "web-ui-components/lib/products/selection"
}, {
  name: "ProductSelector",
  path: "products/selection/ProductSelector",
  styleguidePath: "Products/Selection/ProductSelector",
  importPath: "web-ui-components/lib/products/selection"
}, {
  name: "EmailCreationInput",
  path: "security/authentication/inputs/EmailCreationInput",
  styleguidePath: "Security/Authentication/Inputs/EmailCreationInput",
  importPath: "web-ui-components/lib/security/authentication/inputs"
}, {
  name: "PasswordCreationInput",
  path: "security/authentication/inputs/PasswordCreationInput",
  styleguidePath: "Security/Authentication/Inputs/PasswordCreationInput",
  importPath: "web-ui-components/lib/security/authentication/inputs"
}, {
  name: "CallButtonAnswer",
  path: "telephony/Buttons/CallButton/CallButtonAnswer",
  styleguidePath: "Telephony/Buttons/CallButton/CallButtonAnswer",
  importPath: "web-ui-components/lib/telephony/buttons/callButton"
}, {
  name: "CallButtonClose",
  path: "telephony/Buttons/CallButton/CallButtonClose",
  styleguidePath: "Telephony/Buttons/CallButton/CallButtonClose",
  importPath: "web-ui-components/lib/telephony/buttons/callButton"
}, {
  name: "CallButtonConference",
  path: "telephony/Buttons/CallButton/CallButtonConference",
  styleguidePath: "Telephony/Buttons/CallButton/CallButtonConference",
  importPath: "web-ui-components/lib/telephony/buttons/callButton"
}, {
  name: "CallButtonDial",
  path: "telephony/Buttons/CallButton/CallButtonDial",
  styleguidePath: "Telephony/Buttons/CallButton/CallButtonDial",
  importPath: "web-ui-components/lib/telephony/buttons/callButton"
}, {
  name: "CallButtonEnd",
  path: "telephony/Buttons/CallButton/CallButtonEnd",
  styleguidePath: "Telephony/Buttons/CallButton/CallButtonEnd",
  importPath: "web-ui-components/lib/telephony/buttons/callButton"
}, {
  name: "CallButtonHold",
  path: "telephony/Buttons/CallButton/CallButtonHold",
  styleguidePath: "Telephony/Buttons/CallButton/CallButtonHold",
  importPath: "web-ui-components/lib/telephony/buttons/callButton"
}, {
  name: "CallButtonResume",
  path: "telephony/Buttons/CallButton/CallButtonResume",
  styleguidePath: "Telephony/Buttons/CallButton/CallButtonResume",
  importPath: "web-ui-components/lib/telephony/buttons/callButton"
}, {
  name: "CallButtonRetrieve",
  path: "telephony/Buttons/CallButton/CallButtonRetrieve",
  styleguidePath: "Telephony/Buttons/CallButton/CallButtonRetrieve",
  importPath: "web-ui-components/lib/telephony/buttons/callButton"
}, {
  name: "CallButtonTransfer",
  path: "telephony/Buttons/CallButton/CallButtonTransfer",
  styleguidePath: "Telephony/Buttons/CallButton/CallButtonTransfer",
  importPath: "web-ui-components/lib/telephony/buttons/callButton"
}, {
  name: "Footer",
  path: "typography/ancillary/Footer",
  styleguidePath: "Typography/Ancillary/Footer",
  importPath: "web-ui-components/lib/typography/ancillary"
}, {
  name: "LargeBody",
  path: "typography/body/LargeBody",
  styleguidePath: "Typography/Body/LargeBody",
  importPath: "web-ui-components/lib/typography/body"
}, {
  name: "SmallestBody",
  path: "typography/body/SmallestBody",
  styleguidePath: "Typography/Body/SmallestBody",
  importPath: "web-ui-components/lib/typography/body"
}, {
  name: "StandardBody",
  path: "typography/body/StandardBody",
  styleguidePath: "Typography/Body/StandardBody",
  importPath: "web-ui-components/lib/typography/body"
}, {
  name: "SubBody",
  path: "typography/body/SubBody",
  styleguidePath: "Typography/Body/SubBody",
  importPath: "web-ui-components/lib/typography/body"
}, {
  name: "PageHeading",
  path: "typography/headings/PageHeading",
  styleguidePath: "Typography/Headings/PageHeading",
  importPath: "web-ui-components/lib/typography/headings"
}, {
  name: "SectionHeading",
  path: "typography/headings/SectionHeading",
  styleguidePath: "Typography/Headings/SectionHeading",
  importPath: "web-ui-components/lib/typography/headings"
}, {
  name: "SubHeading",
  path: "typography/headings/SubHeading",
  styleguidePath: "Typography/Headings/SubHeading",
  importPath: "web-ui-components/lib/typography/headings"
}, {
  name: "SubsectionHeading",
  path: "typography/headings/SubsectionHeading",
  styleguidePath: "Typography/Headings/SubsectionHeading",
  importPath: "web-ui-components/lib/typography/headings"
}, {
  name: "LargeHero",
  path: "typography/heros/LargeHero",
  styleguidePath: "Typography/Heros/LargeHero",
  importPath: "web-ui-components/lib/typography/heros"
}, {
  name: "StandardHero",
  path: "typography/heros/StandardHero",
  styleguidePath: "Typography/Heros/StandardHero",
  importPath: "web-ui-components/lib/typography/heros"
}, {
  name: "IndicativeHighlight",
  path: "typography/highlights/IndicativeHighlight",
  styleguidePath: "Typography/Highlights/IndicativeHighlight",
  importPath: "web-ui-components/lib/typography/highlights"
}, {
  name: "StateIndicator",
  path: "typography/indicators/StateIndicator",
  styleguidePath: "Typography/Indicators/StateIndicator",
  importPath: "web-ui-components/lib/typography/indicators"
}, {
  name: "ControlLabel",
  path: "typography/labels/ControlLabel",
  styleguidePath: "Typography/Labels/ControlLabel",
  importPath: "web-ui-components/lib/typography/labels"
}, {
  name: "FieldLabel",
  path: "typography/labels/FieldLabel",
  styleguidePath: "Typography/Labels/FieldLabel",
  importPath: "web-ui-components/lib/typography/labels"
}, {
  name: "ProminentLabel",
  path: "typography/labels/ProminentLabel",
  styleguidePath: "Typography/Labels/ProminentLabel",
  importPath: "web-ui-components/lib/typography/labels"
}, {
  name: "StandardLabel",
  path: "typography/labels/StandardLabel",
  styleguidePath: "Typography/Labels/StandardLabel",
  importPath: "web-ui-components/lib/typography/labels"
}, {
  name: "SubLabel",
  path: "typography/labels/SubLabel",
  styleguidePath: "Typography/Labels/SubLabel",
  importPath: "web-ui-components/lib/typography/labels"
}, {
  name: "BulletList",
  path: "typography/lists/BulletList",
  styleguidePath: "Typography/Lists/BulletList",
  importPath: "web-ui-components/lib/typography/lists"
}, {
  name: "NumberList",
  path: "typography/lists/NumberList",
  styleguidePath: "Typography/Lists/NumberList",
  importPath: "web-ui-components/lib/typography/lists"
}, {
  name: "Identifier",
  path: "typography/modifiers/Identifier",
  styleguidePath: "Typography/Modifiers/Identifier",
  importPath: "web-ui-components/lib/typography/modifiers"
}, {
  name: "AbbreviatedTag",
  path: "typography/tags/AbbreviatedTag",
  styleguidePath: "Typography/Tags/AbbreviatedTag",
  importPath: "web-ui-components/lib/typography/tags"
}, {
  name: "StatusTag",
  path: "typography/tags/StatusTag",
  styleguidePath: "Typography/Tags/StatusTag",
  importPath: "web-ui-components/lib/typography/tags"
}, {
  name: "ValueTag",
  path: "typography/tags/ValueTag",
  styleguidePath: "Typography/Tags/ValueTag",
  importPath: "web-ui-components/lib/typography/tags"
}, {
  name: "StandardValue",
  path: "typography/values/StandardValue",
  styleguidePath: "Typography/Values/StandardValue",
  importPath: "web-ui-components/lib/typography/values"
}, {
  name: "UserStatusBandCard",
  path: "users/business-users/cards/UserStatusBandCard",
  styleguidePath: "Users/Business-users/Cards/UserStatusBandCard",
  importPath: "web-ui-components/lib/users/business-users/cards"
}];
var deprecated = [{
  name: "InputRadio",
  path: "src/actions/radios/InputRadio/package.json",
  deprecations: [{
    replacements: {
      name: "GenericRadio",
      path: "Data/Capture/Radios"
    }
  }]
}, {
  name: "InputRadioGroup",
  path: "src/actions/radios/InputRadioGroup/package.json",
  deprecations: [{
    replacements: {
      name: "GenericRadio",
      path: "Data/Capture/Radios"
    }
  }]
}, {
  name: "Datepicker",
  path: "src/atoms/forms/Datepicker/package.json",
  deprecations: [{
    replacements: {
      name: "Calendar",
      path: "Atoms/Forms"
    }
  }]
}, {
  name: "Radio",
  path: "src/atoms/forms/Radio/package.json",
  deprecations: [{
    replacements: {
      name: "GenericRadio",
      path: "Data/Capture/Radios"
    }
  }]
}, {
  name: "Select",
  path: "src/atoms/forms/Select/package.json",
  deprecations: [{
    replacements: {
      name: "GenericSelect",
      path: "Data/Capture/Selects"
    }
  }]
}, {
  name: "Textarea",
  path: "src/atoms/forms/Textarea/package.json",
  deprecations: [{
    replacements: {
      name: "GenericTextArea",
      path: "Data/Capture/TextAreas"
    }
  }]
}, {
  name: "TextAreaCharacterCount",
  path: "src/atoms/forms/TextAreaCharacterCount/package.json",
  deprecations: [{
    replacements: {
      name: "GenericTextArea",
      path: "Data/Capture/TextAreas"
    }
  }]
}, {
  name: "Icon",
  path: "src/atoms/iconography/Icon/package.json",
  deprecations: [{
    replacements: {
      name: "Icon: ChevronLeftSolidSmall",
      path: "Atoms/Iconography"
    }
  }, {
    replacements: {
      name: "Icon: CrossOutlineLarge or CrossOutlineSmall",
      path: "Atoms/Iconography"
    }
  }, {
    replacements: {
      name: "Icon: CrossSolidLarge or CrossSolidSmall",
      path: "Atoms/Iconography"
    }
  }, {
    replacements: {
      name: "Icon: CycleLarge or CycleSmall",
      path: "Atoms/Iconography"
    }
  }]
}, {
  name: "Divider",
  path: "src/atoms/layout/Divider/package.json",
  deprecations: [{
    replacements: {
      name: "GenericDivider",
      path: "Layout/Content/Breaks"
    }
  }]
}, {
  name: "BankHeader",
  path: "src/atoms/logo/BankHeader/package.json",
  deprecations: [{
    replacements: {
      name: "ContainedHeader",
      path: "Layout/Headers"
    }
  }]
}, {
  name: "Header",
  path: "src/atoms/logo/Header/package.json",
  deprecations: [{
    replacements: {
      name: "ContainedHeader",
      path: "Layout/Headers"
    }
  }]
}, {
  name: "BulletedList",
  path: "src/atoms/text/BulletedList/package.json",
  deprecations: [{
    replacements: {
      name: "BulletList",
      path: "Typography/Lists"
    }
  }]
}, {
  name: "NumberedList",
  path: "src/atoms/text/NumberedList/package.json",
  deprecations: [{
    replacements: {
      name: "NumberList",
      path: "Typography/Lists"
    }
  }]
}, {
  name: "TextBody",
  path: "src/atoms/text/TextBody/package.json",
  deprecations: [{
    replacements: {
      name: "StandardBody",
      path: "Typography/Body"
    }
  }]
}, {
  name: "TextStyled",
  path: "src/atoms/text/TextStyled/package.json",
  deprecations: [{
    replacements: {
      name: "Typography",
      path: "Typography"
    }
  }]
}, {
  name: "AccountLegacyPanel",
  path: "src/finance/accounts/panels/AccountLegacyPanel/package.json",
  deprecations: [{
    replacements: {
      name: "AccountBalancesSelectPanel",
      path: "Finance/Accounts/Panels"
    }
  }]
}, {
  name: "Container",
  path: "src/global/layout/Container/package.json",
  deprecations: [{
    replacements: {
      name: "ContentContainer",
      path: "Layout/Sections"
    }
  }]
}, {
  name: "HeaderSection",
  path: "src/global/layout/Pages/HeaderSection/package.json",
  deprecations: [{
    replacements: {
      name: "ContainedHeader",
      path: "Layout/Headers"
    }
  }]
}, {
  name: "Main",
  path: "src/layout/containers/Main/package.json",
  deprecations: [{
    replacements: {
      name: "ApplicationLayout",
      path: "Layout/Content"
    }
  }],
  accessibility: {
    visual: {
      "colour-contrast": true,
      "font-size": true,
      zoom: false
    },
    auditory: {
      voiceover: false
    },
    "motor-skills": {
      autocomplete: false,
      keyboard: false
    }
  }
}, {
  name: "FixedFooter",
  path: "src/layout/sections/footers/FixedFooter/package.json",
  deprecations: [{
    replacements: {
      name: "MainFixedFooter",
      path: "Layout/Footers"
    }
  }]
}, {
  name: "ContentReveal",
  path: "src/molecules/accordions/ContentReveal/package.json",
  deprecations: [{
    replacements: {
      name: "ContentRevealPanel",
      path: "Layout/Content/Panels"
    }
  }]
}, {
  name: "ValidationMessage",
  path: "src/molecules/forms/ValidationMessage/package.json",
  deprecations: [{
    replacements: {
      name: "ValidationMessageTile",
      path: "Layout/Tiles"
    }
  }]
}, {
  name: "IconText",
  path: "src/molecules/icon-text/IconText/package.json",
  deprecations: [{
    replacements: {
      name: "IconTextDynamic",
      path: "Molecules/IconTextDynamic"
    }
  }]
}, {
  name: "Utility",
  path: "src/molecules/navigation/Utility/package.json",
  deprecations: [{
    replacements: {
      name: "UtilityNav",
      path: "Navigation/Site-Navs/UtilityNav"
    }
  }]
}, {
  name: "SubordinatePanel",
  path: "src/molecules/panels/SubordinatePanel/package.json",
  deprecations: [{
    replacements: {
      name: "ConditionalPanel",
      path: "Layout/Content/Panels"
    }
  }]
}, {
  name: "SectionHeading",
  path: "src/molecules/text/SectionHeading/package.json",
  deprecations: [{
    replacements: {
      name: "SectionHeading",
      path: "Typography/Headings"
    }
  }]
}, {
  name: "CentredModal",
  path: "src/organisms/modals/CentredModal/package.json",
  deprecations: [{
    replacements: {
      name: "ConfirmationModal",
      path: "Organisms/Modals"
    }
  }]
}, {
  name: "Modal",
  path: "src/organisms/modals/Modal/package.json",
  deprecations: [{
    replacements: {
      name: "ConfirmationModal",
      path: "Organisms/Modals"
    }
  }]
}, {
  name: "LargeHero",
  path: "src/typography/heros/LargeHero/package.json",
  deprecations: [{
    replacements: {
      name: "Typography",
      path: "Typography"
    }
  }]
}, {
  name: "StandardHero",
  path: "src/typography/heros/StandardHero/package.json",
  deprecations: [{
    replacements: {
      name: "Typography",
      path: "Typography"
    }
  }]
}];
/* eslint-disable no-console */

var deprecatedDictComponents = {};
var deprecatedDictProps = {};
var timeoutDelay = 100;
var CONSOLE_DEPRECATION_MESSAGE_START = 'Deprecation: web-ui-components';
var DeprecationWarnings = {
  logComponent: function logComponent(componentName) {
    var deprecatedComponentObj = componentPaths.find(function (_ref) {
      var name = _ref.name;
      return name === componentName;
    });
    var oldPath = deprecatedComponentObj.styleguidePath;
    deprecatedComponentObj = deprecated.find(function (_ref2) {
      var name = _ref2.name;
      return name.includes(componentName);
    });
    var newPath = deprecatedComponentObj.deprecations[0].replacements.path + '/' + deprecatedComponentObj.deprecations[0].replacements.name;
    deprecatedDictComponents[componentName] = {
      oldPath: oldPath,
      newPath: newPath
    };
  },
  logIcon: function logIcon(componentName, deprecatedIcon) {
    var deprecatedComponentObj = componentPaths.find(function (_ref3) {
      var name = _ref3.name;
      return name.includes(componentName);
    });
    var path = deprecatedComponentObj.styleguidePath;
    var oldPath = path + ': ' + deprecatedIcon;
    var newPath = path + ': ' + deprecatedIcon;
    var iconName = componentName + ': ' + deprecatedIcon;
    deprecatedDictComponents[iconName] = {
      oldPath: oldPath,
      newPath: newPath
    };
  },
  logProp: function logProp(componentName, path, description) {
    deprecatedDictProps[componentName] = {
      path: path,
      description: description
    };
  },
  report: function report() {
    setTimeout(function () {
      var numberOfDeprecations = Object.keys(deprecatedDictComponents).length + Object.keys(deprecatedDictProps).length;

      if (numberOfDeprecations > 0) {
        console.groupCollapsed('Web UI Components Deprecation Warnings. Total: ' + numberOfDeprecations);
        console.groupCollapsed('Components. Total: ' + Object.keys(deprecatedDictComponents).length);
        Object.entries(deprecatedDictComponents).forEach(function (_ref4) {
          var _ref5 = slicedToArray(_ref4, 2),
              componentName = _ref5[0],
              info = _ref5[1];

          var oldPath = info.oldPath,
              newPath = info.newPath;
          console.groupCollapsed(componentName);
          console.warn('Deprecated:', oldPath);
          console.warn('Replacement:', newPath);
          console.groupEnd();
        });
        console.groupEnd();
        console.groupCollapsed('Props. Total: ' + Object.keys(deprecatedDictProps).length);
        Object.entries(deprecatedDictProps).forEach(function (_ref6) {
          var _ref7 = slicedToArray(_ref6, 2),
              componentName = _ref7[0],
              info = _ref7[1];

          var path = info.path,
              description = info.description;
          console.groupCollapsed(componentName);
          console.warn('Deprecated:', path);
          console.warn('Reason:', description);
          console.groupEnd();
        });
        console.groupEnd();
        console.groupEnd();
        deprecatedDictComponents = {};
        deprecatedDictProps = {};
      }
    }, timeoutDelay);
  },
  warn: function warn(message) {
    return console.warn(CONSOLE_DEPRECATION_MESSAGE_START + ' -> ' + message);
  }
};
Object.freeze(DeprecationWarnings);

var CentredModal = function CentredModal(_ref) {
  var buttonNode = _ref.buttonNode,
      children = _ref.children,
      isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      title = _ref.title;
  DeprecationWarnings.logComponent('CentredModal');
  return React.createElement(BaseModal, {
    hasCentredContent: true,
    isOpen: isOpen,
    onClose: onClose,
    title: title,
    footerContent: buttonNode
  }, React.createElement('div', null, children));
};

CentredModal.propTypes = {
  /** Button content node */
  buttonNode: PropTypes.node.isRequired,

  /** Modal body child content */
  children: PropTypes.node.isRequired,

  /** Initial visibility state of the modal */
  isOpen: PropTypes.bool,

  /** Modal close handler */
  onClose: PropTypes.func.isRequired,

  /** The modal title string */
  title: PropTypes.string.isRequired
};
CentredModal.defaultProps = {
  isOpen: false
};
var alignmentOptions = ['left', 'center', 'right'];
/** The ButtonGroup is used to contain and align one or more anchor or button component(s).  */

var ButtonGroup = function ButtonGroup(_ref) {
  var alignment = _ref.alignment,
      children = _ref.children;
  var buttonGroupClasses = classnames('c-m-button-group', {
    'u-flex-justify-content-center': alignment === 'center',
    'u-flex-justify-content-flex-end': alignment === 'right'
  });
  return React.createElement('div', {
    className: buttonGroupClasses
  }, children);
};

ButtonGroup.propTypes = {
  /** Sets the options for different alignment variations on the children. */
  alignment: PropTypes.oneOf(alignmentOptions),

  /** An array of elements, rendered as children within the button group. */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.element])
};
ButtonGroup.defaultProps = {
  alignment: 'left'
};

var ButtonTitle = function ButtonTitle(_ref) {
  var children = _ref.children;
  return React.createElement('span', {
    className: 'c-a-button__title'
  }, children);
};

ButtonTitle.propTypes = {
  children: PropTypes.node
};

var _extends$1 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var LoadingOutlineSmallIcon = function LoadingOutlineSmallIcon(_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends$1({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M17.62 6.306L15.406 8.52a4.87 4.87 0 1 0 0 6.96l2.214 2.214a8 8 0 1 1 0-11.388z"
  }));
};

var wrapTextNodes = function wrapTextNodes(children) {
  return React.Children.map(children, function (child) {
    return typeof child === 'string' ? React.createElement(ButtonTitle, null, child) : child;
  });
};

var Button = function (_Component) {
  inherits(Button, _Component);

  function Button(props) {
    classCallCheck(this, Button);

    var _this = possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this, props));

    _this.buttonRef = null;
    return _this;
  }

  createClass(Button, [{
    key: 'focus',
    value: function focus() {
      if (this.buttonRef) {
        this.buttonRef.focus();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames,
          _this2 = this; // eslint-disable-next-line react/prop-types


      var _props = this.props,
          children = _props.children,
          isLoading = _props.isLoading,
          loadingText = _props.loadingText,
          width = _props.width,
          display = _props.display,
          size = _props.size,
          className = _props.className,
          disabled = _props.disabled,
          rest = objectWithoutProperties(_props, ['children', 'isLoading', 'loadingText', 'width', 'display', 'size', 'className', 'disabled']);
      var allClassNames = classnames(className, 'c-a-button', (_classnames = {}, defineProperty(_classnames, 'c-a-button--width-' + width, width), defineProperty(_classnames, 'c-a-button--size-' + size, size), defineProperty(_classnames, 'c-a-button--' + display, display), defineProperty(_classnames, 'c-a-button--is-spinning', isLoading), _classnames));

      var buttonProps = _extends({
        disabled: isLoading || disabled
      }, isLoading && {
        'aria-live': 'polite'
      }, isLoading && {
        'aria-busy': 'true'
      }, rest);

      return React.createElement('button', _extends({
        className: allClassNames,
        ref: function ref(component) {
          _this2.buttonRef = component;
        }
      }, buttonProps), wrapTextNodes(children), isLoading && React.createElement('div', {
        className: 'c-a-button__loading-spinner'
      }, React.createElement('span', {
        className: 'c-a-button__loading-spinner-icon'
      }, React.createElement(LoadingOutlineSmallIcon, null)), React.createElement('span', {
        className: 'c-a-button__loading-spinner-label'
      }, loadingText)));
    }
  }]);
  return Button;
}(Component);

Button.propTypes = {
  /** Child content as single node or array of nodes. */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),

  /** Sets a custom class name. */
  className: PropTypes.string,

  /** Controls the button disabled state. */
  disabled: PropTypes.bool,

  /** Specify a display type. */
  display: PropTypes.oneOf(['primary', 'secondary']),

  /** Controls the loading state of the button. */
  isLoading: PropTypes.bool,

  /** Sets the text when the isLoading prop is set to true. */
  loadingText: PropTypes.string,

  /** Click handler invoked when the button is clicked. */
  onClick: PropTypes.func,

  /** Sets the size. */
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),

  /** Sets the width. */
  width: PropTypes.oneOf(['flush', 'narrow', 'wide', 'full'])
};
Button.defaultProps = {
  isLoading: false,
  loadingText: 'Loading',
  size: 'md',
  disabled: false
};

var ConfirmationModal = function ConfirmationModal(_ref) {
  var children = _ref.children,
      confirmButtonIsDisabled = _ref.confirmButtonIsDisabled,
      confirmButtonText = _ref.confirmButtonText,
      dismissButtonIsDisabled = _ref.dismissButtonIsDisabled,
      dismissButtonText = _ref.dismissButtonText,
      isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      onConfirm = _ref.onConfirm,
      title = _ref.title;
  var buttonGroup = React.createElement(ButtonGroup, null, React.createElement(Button, {
    display: 'secondary',
    disabled: dismissButtonIsDisabled,
    size: 'sm',
    onClick: onClose
  }, dismissButtonText), React.createElement(Button, {
    display: 'primary',
    disabled: confirmButtonIsDisabled,
    size: 'sm',
    onClick: onConfirm
  }, confirmButtonText));
  return React.createElement(BaseModal, {
    isOpen: isOpen,
    onClose: onClose,
    title: title,
    footerContent: buttonGroup
  }, React.createElement('div', null, children));
};

ConfirmationModal.propTypes = {
  /** Modal body child content */
  children: PropTypes.node.isRequired,

  /** Confirm button disabled status. */
  confirmButtonIsDisabled: PropTypes.bool,

  /** Confirm button text */
  confirmButtonText: PropTypes.string,

  /** Dismiss  button disabled status. */
  dismissButtonIsDisabled: PropTypes.bool,

  /** Dismissal button text */
  dismissButtonText: PropTypes.string,

  /** Initial visibility state of the modal */
  isOpen: PropTypes.bool,

  /** Modal close handler */
  onClose: PropTypes.func.isRequired,

  /** Modal confirmation click handler function */
  onConfirm: PropTypes.func.isRequired,

  /** The modal title string */
  title: PropTypes.string.isRequired
};
ConfirmationModal.defaultProps = {
  confirmButtonIsDisabled: false,
  confirmButtonText: 'OK',
  dismissButtonIsDisabled: false,
  dismissButtonText: 'Cancel',
  isOpen: false
};

var _templateObject$5 = taggedTemplateLiteral(['\n\tbackground-color: ', ';\n\tbottom: 0;\n\tleft: 0;\n\tposition: fixed;\n\topacity: 0.7;\n\tright: 0;\n\ttop: 0;\n\tz-index: ', ';\n'], ['\n\tbackground-color: ', ';\n\tbottom: 0;\n\tleft: 0;\n\tposition: fixed;\n\topacity: 0.7;\n\tright: 0;\n\ttop: 0;\n\tz-index: ', ';\n']),
    _templateObject2$5 = taggedTemplateLiteral(['\n\topacity: 1;\n\tclip: auto;\n\theight: auto;\n\twidth: auto;\n\toverflow: visible;\n\tposition: fixed;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\tleft: 0;\n\tz-index: ', ';\n\tcolor: ', ';\n\tuser-select: none;\n\ttransition: opacity 0.35s ease-in-out;\n\t', ';\n'], ['\n\topacity: 1;\n\tclip: auto;\n\theight: auto;\n\twidth: auto;\n\toverflow: visible;\n\tposition: fixed;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\tleft: 0;\n\tz-index: ', ';\n\tcolor: ', ';\n\tuser-select: none;\n\ttransition: opacity 0.35s ease-in-out;\n\t', ';\n']),
    _templateObject3$2 = taggedTemplateLiteral(['\n\talign-items: center;\n\tbackground: ', ';\n\tborder-radius: ', ';\n\tdisplay: flex;\n\tflex-direction: column;\n\theight: 340px;\n\tjustify-content: center;\n\tmax-height: 50vh;\n\tmax-width: 90vw;\n\tmin-height: 248px;\n\tpadding: 24px;\n\twidth: 640px;\n'], ['\n\talign-items: center;\n\tbackground: ', ';\n\tborder-radius: ', ';\n\tdisplay: flex;\n\tflex-direction: column;\n\theight: 340px;\n\tjustify-content: center;\n\tmax-height: 50vh;\n\tmax-width: 90vw;\n\tmin-height: 248px;\n\tpadding: 24px;\n\twidth: 640px;\n']),
    _templateObject4$2 = taggedTemplateLiteral(['\n\talign-items: center;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\theight: 100%;\n\tpadding-left: ', ';\n\tpadding-right: ', ';\n'], ['\n\talign-items: center;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\theight: 100%;\n\tpadding-left: ', ';\n\tpadding-right: ', ';\n']),
    _templateObject5$1 = taggedTemplateLiteral(['\n\tmargin-bottom: ', ';\n\t', ';\n'], ['\n\tmargin-bottom: ', ';\n\t', ';\n']),
    _templateObject6$1 = taggedTemplateLiteral(['\n\tpadding-bottom: ', ';\n\ttext-align: center;\n\t', ';\n'], ['\n\tpadding-bottom: ', ';\n\ttext-align: center;\n\t', ';\n']),
    _templateObject7$1 = taggedTemplateLiteral(['\n\tpadding-bottom: ', ';\n\ttext-align: center;\n\tp {\n\t\tmargin-bottom: ', ';\n\t\t&:last-child {\n\t\t\tmargin-bottom: 0;\n\t\t}\n\t}\n'], ['\n\tpadding-bottom: ', ';\n\ttext-align: center;\n\tp {\n\t\tmargin-bottom: ', ';\n\t\t&:last-child {\n\t\t\tmargin-bottom: 0;\n\t\t}\n\t}\n']);

injectGlobal('\n\t.has-global-takeover {\n\t\toverflow: hidden;\n\t}\n');
var StyledBackdrop = styled('div')(_templateObject$5, colours.backgrounds.modalBackdrop, layers.sub);
var StyledTakeover = styled('div')(_templateObject2$5, layers.loader, function (props) {
  return props.theme.components.loader.colours.color;
}, function (props) {
  return !props.isOpen && '\n\t\tdisplay: none!important\n\t';
});
var StyledContent = styled('div')(_templateObject3$2, function (props) {
  return props.theme.components.loader.colours.background;
}, function (props) {
  return props.theme.borderRadiusLargest;
});
var StyledContentWrapper = styled('div')(_templateObject4$2, spacing(2), spacing(2));
var StyledMedia = styled('div')(_templateObject5$1, spacing(1), function (props) {
  return props.theme.name !== 'vm' && 'svg {\n\t\t\twidth: ' + spacing(6) + ';\n\t\t\theight: ' + spacing(6) + ';\n\t\t\tfill: ' + colours.neutral.white + ';\n\t\t\tanimation: ' + animations.rotate + ' 1.25s linear infinite;\n\t\t}';
});
var StyledTitleWrapper = styled('div')(_templateObject6$1, spacing(2), fontSize('mull'));
var StyledBodyWrapper = styled('div')(_templateObject7$1, spacing(2), spacing(1));

var toggleBodyClass = function toggleBodyClass(flag) {
  if (flag) {
    document.body.classList.add('has-global-takeover');
  } else {
    document.body.classList.remove('has-global-takeover');
  }
};

var Loader = function (_Component) {
  inherits(Loader, _Component);

  function Loader() {
    classCallCheck(this, Loader);
    return possibleConstructorReturn(this, (Loader.__proto__ || Object.getPrototypeOf(Loader)).apply(this, arguments));
  }

  createClass(Loader, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      toggleBodyClass(this.props.isOpen);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var isOpen = this.props.isOpen;

      if (!isOpen && nextProps.isOpen) {
        toggleBodyClass(true);
      } else if (isOpen && !nextProps.isOpen) {
        toggleBodyClass(false);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      toggleBodyClass(false);
    }
  }, {
    key: 'render',
    value: function render() {
      // eslint-disable-next-line react/prop-types
      var _props = this.props,
          title = _props.title,
          titleID = _props.titleID,
          body = _props.body,
          children = _props.children,
          isOpen = _props.isOpen,
          theme = _props.theme;
      var bodyFont = theme.components.loader.fonts.body;
      var loadingSpinner = theme.components.loader.root.loadingSpinner;
      var titleFont = theme.components.loader.fonts.title;
      return React.createElement(StyledTakeover, {
        'aria-labelledby': titleID,
        'aria-live': 'polite',
        isOpen: isOpen,
        tabIndex: '-1',
        role: 'dialog'
      }, React.createElement(StyledContentWrapper, null, React.createElement(StyledContent, null, React.createElement(StyledMedia, null, loadingSpinner), React.createElement(StyledTitleWrapper, {
        id: titleID
      }, titleFont(title)), body && React.createElement(StyledBodyWrapper, null, bodyFont(body)), children)), React.createElement(StyledBackdrop, null));
    }
  }]);
  return Loader;
}(Component);

Loader.propTypes = {
  /** Boolean controlling whether loader is shown or not. */
  isOpen: PropTypes.bool.isRequired,

  /** Loader title text. */
  title: PropTypes.string,

  /** ID attribute for title, used to add accessibility aria attributes for screen readers. */
  titleID: PropTypes.string,

  /** Loader body text. */
  body: PropTypes.string,

  /** Child content as element, node or string. */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.node, PropTypes.string])
};
Loader.defaultProps = {
  title: 'Please wait'
};
var WrappedLoader = withTheme(Loader);

var ModalBody$1 = function ModalBody(_ref) {
  var children = _ref.children,
      title = _ref.title,
      scrollable = _ref.scrollable;
  return React.createElement('div', {
    className: 'c-o-modal__body modal-body',
    style: {
      overflowY: scrollable ? 'auto' : 'inherit'
    }
  }, title && React.createElement('h3', {
    className: 'c-o-modal__title modal-title'
  }, title), children);
};

ModalBody$1.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  scrollable: PropTypes.bool
};
ModalBody$1.defaultProps = {
  scrollable: false
};

var _templateObject$6 = taggedTemplateLiteral(['\n\tz-index: -1 !important;\n'], ['\n\tz-index: -1 !important;\n']);

var StyledModalBackdrop$1 = styled('div')(_templateObject$6);

var ModalContainer$1 = function ModalContainer(_ref) {
  var children = _ref.children,
      handleClick = _ref.handleClick;
  return React.createElement('div', {
    role: 'presentation',
    className: 'c-o-modal__inner',
    onClick: handleClick,
    onKeyUp: handleClick
  }, React.createElement('div', {
    className: 'c-o-modal__dialog modal-dialog',
    role: 'document'
  }, React.createElement('div', {
    role: 'presentation',
    className: 'c-o-modal__content modal-content',
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    onKeyUp: function onKeyUp(e) {
      return e.stopPropagation();
    }
  }, children)), React.createElement(StyledModalBackdrop$1, {
    className: 'modal-backdrop fade show'
  }));
};

ModalContainer$1.propTypes = {
  children: PropTypes.node,
  handleClick: PropTypes.func
};

var ModalHeader$1 = function ModalHeader(_ref) {
  var children = _ref.children;
  return React.createElement('div', {
    className: 'c-o-modal__header modal-header'
  }, children);
};

ModalHeader$1.propTypes = {
  children: PropTypes.node
};

var ModalFooter$1 = function ModalFooter(_ref) {
  var children = _ref.children;
  return React.createElement('div', {
    className: 'c-o-modal__footer modal-footer'
  }, children);
};

ModalFooter$1.propTypes = {
  children: PropTypes.node
};
injectGlobal('\n\t.react-modal__overlay {\n\t\tdisplay: block !important;\n\t}\n\t.react-modal__dialog {\n\t\toutline: none !important;\t\n\t}\n');
var removeDefaultClasses$1 = {
  base: '',
  afterOpen: '',
  beforeClose: ''
};

var sanitiseSize = function sanitiseSize(size) {
  return {
    sm: 'small',
    md: 'medium',
    lg: 'large'
  }[size] || 'medium';
};

var Modal = function Modal(_ref) {
  var isOpen = _ref.isOpen,
      onAfterOpen = _ref.onAfterOpen,
      onRequestClose = _ref.onRequestClose,
      shouldCloseOnOverlayClick = _ref.shouldCloseOnOverlayClick,
      title = _ref.title,
      size = _ref.size,
      header = _ref.header,
      children = _ref.children,
      footer = _ref.footer,
      customMainClass = _ref.customMainClass,
      scrollable = _ref.scrollable,
      returnFocusAfterClose = _ref.returnFocusAfterClose;
  DeprecationWarnings.logComponent('Modal');
  return React.createElement(ReactModal, {
    appElement: document.body,
    bodyOpenClassName: customMainClass ? customMainClass + ' modal-open' : 'modal-open',
    className: _extends({}, removeDefaultClasses$1, {
      base: 'react-modal__dialog'
    }),
    closeTimeoutMS: 300,
    contentLabel: 'Modal',
    isOpen: isOpen,
    onAfterOpen: onAfterOpen,
    onRequestClose: onRequestClose,
    overlayClassName: {
      base: 'c-o-modal react-modal__overlay fade modal c-o-modal--' + sanitiseSize(size),
      afterOpen: 'show',
      beforeClose: 'hide'
    },
    shouldReturnFocusAfterClose: returnFocusAfterClose
  }, React.createElement(ModalContainer$1, {
    animationClass: onAfterOpen(),
    handleClick: function handleClick() {
      return shouldCloseOnOverlayClick ? onRequestClose() : function () {};
    }
  }, header && React.createElement(ModalHeader$1, null, header), React.createElement(ModalBody$1, {
    scrollable: scrollable,
    title: title
  }, children), footer && React.createElement(ModalFooter$1, null, footer)));
};

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  footer: PropTypes.node,
  header: PropTypes.node.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onAfterOpen: PropTypes.func,
  onRequestClose: PropTypes.func,
  shouldCloseOnOverlayClick: PropTypes.bool,
  size: PropTypes.string,
  title: PropTypes.string,
  customMainClass: PropTypes.string,
  scrollable: PropTypes.bool,
  returnFocusAfterClose: PropTypes.bool
};
Modal.defaultProps = {
  size: 'md',
  onAfterOpen: function onAfterOpen() {},
  returnFocusAfterClose: false
};

var wrapperClasses = function wrapperClasses(type) {
  return classnames('c-m-highlight-tile', defineProperty({}, 'u-background-color-utility-' + type + '-tint', type));
};

var HighlightTile = function HighlightTile(_ref) {
  var type = _ref.type,
      children = _ref.children;
  return React.createElement('div', {
    className: wrapperClasses(type)
  }, children);
};

HighlightTile.propTypes = {
  /** This makes up the content within the Highlight Tile. */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),

  /** Allows the choice of which type of background highlight */
  type: PropTypes.oneOf(['tip', 'note', 'info', 'warning']).isRequired
};

var UnfinishedWorkModal = function UnfinishedWorkModal(_ref) {
  var children = _ref.children,
      destructiveActionButtonText = _ref.destructiveActionButtonText,
      isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      onDestructiveAction = _ref.onDestructiveAction,
      safeActionButtonText = _ref.safeActionButtonText,
      title = _ref.title;
  var buttonGroup = React.createElement(ButtonGroup, {
    alignment: 'right'
  }, React.createElement(Button, {
    display: 'secondary',
    size: 'sm',
    onClick: onDestructiveAction
  }, destructiveActionButtonText), React.createElement(Button, {
    autoFocus: true,
    display: 'primary',
    size: 'sm',
    onClick: onClose
  }, safeActionButtonText));
  return React.createElement(BaseModal, {
    isOpen: isOpen,
    onClose: onClose,
    title: title,
    footerContent: buttonGroup
  }, React.createElement(HighlightTile, {
    type: 'warning'
  }, children));
};

UnfinishedWorkModal.propTypes = {
  /** Modal body child content */
  children: PropTypes.node.isRequired,

  /** Destructive action button text */
  destructiveActionButtonText: PropTypes.string.isRequired,

  /** Initial visibility state of the modal */
  isOpen: PropTypes.bool,

  /** Modal close handler */
  onClose: PropTypes.func.isRequired,

  /** Modal destructive action click handler function */
  onDestructiveAction: PropTypes.func.isRequired,

  /** Safe action button text */
  safeActionButtonText: PropTypes.string.isRequired,

  /** The modal title string */
  title: PropTypes.string.isRequired
};
UnfinishedWorkModal.defaultProps = {
  isOpen: false
};
export { CentredModal, ConfirmationModal, WrappedLoader as Loader, Modal, UnfinishedWorkModal };